/*
 * Program: MroNotes.jsx
 * Application: MroNotes
 * Option: to List out of MroNotes Information
 * Developer: Chandra Shekhar
 * Date: 18-04-2022
 */
import React, { Component } from "react";
import Moment from "moment";
import SimpleReactValidator from "simple-react-validator";
import DailyLogService from "../../services/DailyLogService";
import { Form, Modal, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
// import Select from "react-select";
import PropertyService from "../../services/PropertyService";
import Alerts from "../common/Alerts";
import back from "./../../assets/images/back.svg";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import CustomToolbar from "../CustomToolbar";
import LinkModal from "../LinkModal";
import FileWidget from "../fileUploader/FileWidget";
import placeholderImage from "./../../assets/images/image-placeholder.png";
import ActionItemService from "../../services/ActionItemService";
import DeleteImageModal from "../DeleteImageModal";
import ReactImageMagnify from "react-image-magnify";
import AuditService from "../../services/AuditService";
import deleteicon from "../../assets/images/delete-gray.svg";
import EditpenIcon from "./../../assets/images/edit-pen-icon.svg";
import downArrow from "./../../assets/images/down-arrow-icon.svg";
import MoreInfoIcon from "./../../assets/images/more-info-icon.svg";
import DatePicker from "react-datepicker";
import imageCompression from "browser-image-compression";
const userSessionData =
  JSON.parse(localStorage.getItem("userData")) || this?.props?.userData;

export class DailyLogDetail extends Component {
  constructor(props) {
    super(props);
    this.unblock = null;
    this.validator = new SimpleReactValidator({ autoForceUpdate: this });
    this.quillRef = React.createRef();
    this.modalQuillRef = React.createRef();
    let today = new Date();
    if (this.props.location?.state?.selectedDate) {
     today = this.props.location?.state?.selectedDate;
    }
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day   = String(today.getDate()).padStart(2, '0');
    const year  = today.getFullYear(); 
    const formattedDate = `${month}.${day}.${year}`;
    this.state = {
      showModal: false,
      showModalImage: false,
      range: null,
      url: "",
      text: "",
      isEditing: false,
      showSpinner: false,
      loading: false,
      showAlertModal: false,
      alertModalType: "",
      alertModalTitle: "",
      alertModalMessage: "",
      showAlertModal1: false,
      alertModalType1: "",
      alertModalTitle1: "",
      alertModalMessage1: "",
      input: {},
      errors: {},
      isSubmit: false,
      isfromstaff: false,
      isfromkey_staff: false,
      isfromscores: false,
      isfromfnb_results: false,
      isfromsales: false,
      isfromforward_looking: false,
      isfromtasks: false,
      total_record: 0,
      records: [],
      slug: this.props.match.params.slug,
      selectedPropertyList: [],
      propertyList: [],
      property_slug: this.props.location?.state?.selectedProperty?.value || "",
      inputDataDailyLog: {},
      note: "",
      daily_log_note: "",
      activeEditor: null,
      dailyLogImages: [],
      deletedFileList: [],
      title: `${formattedDate} Daily Log`,
      selectedProperty: this.props.location?.state?.selectedProperty || null,
      selectedDate: this.props.location?.state?.selectedDate || null,
      templateData: null,
      templateSections: [],
      showTemplate: false,
      openCategories: {},
      showLogEntryModal: false,
      currentLogCategory: "",
      newLogEntry: "",
      showReplyModal: false,
      currentReplyIndex: null,
      newReply: "",
      templateShow: false,
      versions: [],
      logEntryImages: [],
      arrAllImages: [],
      daily_log_slug: this.props.location.state?.slug || "",
      showDeleteReplyModal: false,
      replyToDelete: null,
      replyCategory: null,
      replyEntryIndex: null,
      replyIndex: null,
      showVersionHistory: false,
      hasUnsavedChanges: false,
      showConfirmModal: false,
      confirmNavigation: null,
      collapsedSections: {},
      savingSection: null,
      deletedImages: [],
      isDisabled: false,
      replyImages: [], // Add this for reply images
      replyDeletedImages: [], // Add this for tracking deleted reply images
      replyUploadProgress: 0, // Add this for upload progress
      replyUploadStatus: "", // Add this for upload status
      isUploadingReply: false,
      isRefreshing: false,
      showEventDetailModal: false,
      eventDetailData: [],
      showAddNewdailylogConfirmModal: false,
      showPastDatedailylogInfoModal: false,
      filter_for_daily_log: '',
      selectedPropertyLog : [],
      selectedProperty1 : [],
    };

    this.saveDailyLogs = this.saveDailyLogs.bind(this);
    this.saveDailyLogThread = this.saveDailyLogThread.bind(this);
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    // this.handleChange = this.handleChange.bind(this);
    this.handleChangeReply = this.handleChangeReply.bind(this);
    this.handleChangeModal = this.handleChangeModal.bind(this);
    this.handleLinkClick = this.handleLinkClick.bind(this);
    this.handleModalRemove = this.handleModalRemove.bind(this);
    this.handleLink = this.handleLink.bind(this);
    this.handleModalEditorLink = this.handleModalEditorLink.bind(this);
    this.handleModalClose = this.handleModalClose.bind(this);
    this.handleModalSubmit = this.handleModalSubmit.bind(this);
    this.deleteImage = this.deleteImage.bind(this);
    this.opendeleteDailyLogModal = this.opendeleteDailyLogModal.bind(this);
    this.opendeleteDailyLogThreadModal =
      this.opendeleteDailyLogThreadModal.bind(this);
    this.openLogEntryModal = this.openLogEntryModal.bind(this);
    this.handleRefresh = this.handleRefresh.bind(this);
    this.getEventDetail = this.getEventDetail.bind(this);
    this.exportPdf = this.exportPdf.bind(this);
  }

  componentDidMount() {
    if (this.state.slug !== "add") {
      this.getData();
      this.getVersion();
    }
    if (this.state.slug == "add") {
      this.getTemplate();
    }
    this.getPropertyList();
    if (this.state.slug === undefined) {
      const quill = this.quillRef.current
        ? this.quillRef.current.getEditor()
        : null;
      if (quill) {
        quill.root.removeEventListener("click", this.handleLinkClick);
      }

      const modalQuill = this.modalQuillRef.current
        ? this.modalQuillRef.current.getEditor()
        : null;
      if (modalQuill) {
        modalQuill.root.removeEventListener("click", this.handleLinkClick);
      }
    }
    this.unblock = this.props.history.block((tx) => {
      // Don't block if thread is enabled or no unsaved changes
      if (this.state.is_thread_enable === 2 || !this.state.hasUnsavedChanges) {
        return true;
      }

      // Block navigation and show confirmation
      this.setState({
        showConfirmModal: true,
        confirmNavigation: () => {
          this.unblock(); // Clean up blocker
          this.props.history.push(tx.pathname);
        },
      });
      return false;
    });
  }

  handleRefresh = async () => {
    this.setState({ isRefreshing: true });

    try {
      // Call both APIs
      await this.getData();
      await this.getVersion();
    } catch (error) {
      console.error("Error refreshing data:", error);
      this.setState({
        showAlertModal: true,
        alertModalType: "error",
        alertModalTitle: "Refresh Error",
        alertModalMessage: "Failed to refresh data. Please try again.",
      });
    } finally {
      this.setState({ isRefreshing: false });
    }
  };
  setUnsavedChanges = (hasChanges) => {
    this.setState({ hasUnsavedChanges: hasChanges });
  };

  handleBlockedNavigation = (nextLocation) => {
    const { hasUnsavedChanges } = this.state;

    if (
      hasUnsavedChanges &&
      nextLocation.pathname !== this.props.location.pathname
    ) {
      this.setState({
        showConfirmModal: true,
        confirmNavigation: () => this.props.history.push(nextLocation.pathname),
      });
      return false;
    }
    return true;
  };

  handleBackClick = (e) => {
    e.preventDefault();

    // Don't show confirmation if thread is enabled or no unsaved changes
    if (this.state.is_thread_enable === 2 || !this.state.hasUnsavedChanges) {
      this.props.history.push("/daily-logs");
      return;
    }

    this.setState({
      showConfirmModal: true,
      confirmNavigation: () => {
        this.unblock(); // Clean up blocker
        this.props.history.push("/daily-logs");
      },
    });
  };

  confirmNavigation = () => {
    this.setState({ showConfirmModal: false, hasUnsavedChanges: false }, () => {
      if (this.state.confirmNavigation) {
        // Unblock navigation first
        this.unblock();
        // Execute the stored navigation function
        this.state.confirmNavigation();
      }
    });
  };

  cancelNavigation = () => {
    this.setState({ showConfirmModal: false, confirmNavigation: null ,showAddNewdailylogConfirmModal: false,showPastDatedailylogInfoModal: false});
  };

  limitTextTo50Words(htmlContent) {
    // Parse HTML content to extract text
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlContent, "text/html");
    const textContent = doc.body.textContent || "";

    // Limit the text content to 50 characters
    const limit = 150;
    let result = textContent.slice(0, limit);

    // Append "..." if the original content is longer than 50 characters
    if (textContent.length > limit) {
      result += "...";
    }
    return result;
  }
  focusQuillEditor = (setToEnd = false) => {
    if (this.modalQuillRef.current) {
      const editor = this.modalQuillRef.current.getEditor();
      if (setToEnd) {
        // Set cursor to end of text
        const length = editor.getLength();
        editor.setSelection(length, 0);
      }
      editor.focus();
    }
  };
  focusQuillEditorReply = (quillRef, setToEnd = false) => {
    if (quillRef.current) {
      const editor = quillRef.current.getEditor();
      if (setToEnd) {
        const length = editor.getLength();
        editor.setSelection(length, 0); // Move cursor to end
      }
      editor.focus();
    }
  };
  openLogEntryModal = (
    category,
    entryIndex = null,
    entry = null,
    e,
    addNew
  ) => {
    if (e) e.preventDefault();

    // Ensure `entry` is an object with `text` and `images`
    const entryText = entry?.text || ""; // Fallback to empty string if undefined
    const entryImages = entry?.images || [];

    this.setState(
      {
        showLogEntryModal: true,
        currentLogCategory: category,
        currentEntryIndex: entryIndex,
        newLogEntry: entryText,
        editingEntry: entry,
        isEditingEntry: addNew == 2 ? true : false,
        logEntryImages: entryImages,
        loading: false,
        daily_log_thread_slug:
          addNew == 2 ? entry.slug || this.state.daily_log_thread_slug : "",
      },
      () => {
        // This callback runs after state is updated
        setTimeout(() => {
          this.focusQuillEditor();
        }, 100); // Small timeout to ensure modal is fully rendered
      }
    );
  };

  closeLogEntryModal = () => {
    this.setState({
      showLogEntryModal: false,
      currentLogCategory: "",
      newLogEntry: "",
      loading: false,
      deletedImages: [],
    });
  };

  openReplyModal = (
    category,
    entryIndex,
    replyIndex = null,
    e,
    entrySlug,
    replySlug,
    addNew
  ) => {
    if (e) e.preventDefault();
    const logSection = this.state.templateSections.find(
      (s) => s.section_type === "log_entries"
    );
    let originalText = "";

    if (logSection?.logs?.[category]?.entries?.[entryIndex]) {
      originalText = logSection.logs[category].entries[entryIndex].text;
    }
    let currentReply = "";
    let currentReplyImages = [];

    // If editing an existing reply, get its text and images
    if (
      replyIndex !== null &&
      logSection?.logs?.[category].entries?.[entryIndex]?.replies?.[replyIndex]
    ) {
      currentReply =
        logSection?.logs?.[category].entries?.[entryIndex]?.replies?.[
          replyIndex
        ].text;
      currentReplyImages =
        logSection?.logs?.[category].entries?.[entryIndex]?.replies?.[
          replyIndex
        ].images || [];
    }

    this.setState(
      {
        showReplyModal: true,
        currentReplyCategory: category,
        currentEntryIndex: entryIndex,
        currentReplyIndex: replyIndex,
        originalLogEntryText: originalText,
        newReply: currentReply,
        replyImages: currentReplyImages, // Load existing reply images
        daily_log_thread_slug: entrySlug || this.state.daily_log_thread_slug,
        daily_log_replies_slug:
          addNew === 2 ? replySlug || this.state.daily_log_replies_slug : "",
      },
      () => {
        // Auto-focus with cursor at end if editing
        setTimeout(() => {
          this.focusQuillEditorReply(this.quillRef, addNew === 2);
        }, 100);
      }
    );
  };

  async getEventDetail(eventSlug) {
    this.setState({ showSpinner: true });
    let res = await DailyLogService.getEventDetails(eventSlug);
    if (global.successStatus.includes(res.status)) {
      this.setState({
        eventDetailData: res.data,
        showEventDetailModal: true,
        showSpinner: false,
      });
    } else {
      this.setState({ showSpinner: false });
    }
  }

  // Close Event modal
  closeEventDetailModal = () => {
    this.setState({
      showEventDetailModal: false,
    });
    this.setState({ showSpinner: false });
  };

  formatTime = (timeString) => {
    if (!timeString) return "";
    const [hours, minutes] = timeString.split(":");
    const hour = parseInt(hours, 10);
    const ampm = hour >= 12 ? "PM" : "AM";
    const hour12 = hour % 12 || 12;
    return `${hour12}:${minutes} ${ampm}`;
  };

  // Close reply modal
  closeReplyModal = () => {
    this.setState({
      showReplyModal: false,
      currentLogCategory: "",
      currentReplyIndex: null,
      newReply: "",
    });
  };

  componentWillUnmount() {
    if (this.unblock) {
      this.unblock(); // Clean up the navigation blocker
    }
    if (this.state.slug === undefined) {
      const quill = this.quillRef.current
        ? this.quillRef.current.getEditor()
        : null;
      if (quill) {
        quill.root.removeEventListener("click", this.handleLinkClick);
      }

      const modalQuill = this.modalQuillRef.current
        ? this.modalQuillRef.current.getEditor()
        : null;
      if (modalQuill) {
        modalQuill.root.removeEventListener("click", this.handleLinkClick);
      }
    }
  }

  handleLink() {
    const quill = this.quillRef.current.getEditor();
    const range = quill.getSelection();
    if (range) {
      this.setState({
        showModal: true,
        range,
        url: "",
        text: "",
        isEditing: false,
        activeEditor: "main",
      });
    }
  }

  handleModalEditorLink() {
    const quill = this.modalQuillRef.current?.getEditor();
    const range = quill?.getSelection();
    if (range) {
      this.setState({
        showModal: true,
        range,
        url: "",
        text: "",
        isEditing: false,
        activeEditor: "modal",
      });
    }
  }

  handleModalClose() {
    this.setState({
      showModal: false,
      range: null,
      url: "",
      text: "",
      isEditing: false,
    });
  }

  handleModalSubmit(url, text) {
    const { range, activeEditor } = this.state;
    let quill = null;

    if (activeEditor === "main") {
      quill = this.quillRef.current?.getEditor();
    } else if (activeEditor === "modal") {
      quill = this.modalQuillRef.current?.getEditor();
    }

    if (range && url && text && quill) {
      quill.deleteText(range.index, range.length);
      quill.insertText(range.index, text, "link", url);
      quill.setSelection(range.index + text.length);
    }
    this.setState({
      showModal: false,
      range: null,
      url: "",
      text: "",
      isEditing: false,
      activeEditor: null,
    });
  }

  handleLinkClick(event) {
    if (event.target.tagName === "A") {
      event.preventDefault();
      const quill = this.quillRef.current.getEditor();
      const range = quill.getSelection();
      const url = event.target.getAttribute("href");
      const text = event.target.innerText;

      // Prevent Quill's tooltip from showing
      quill.blur();

      this.setState({
        showModal: true,
        range: { index: range.index, length: text.length },
        url,
        text,
        isEditing: true,
      });
    }
  }

  handleModalRemove() {
    const quill = this.quillRef.current.getEditor();
    const textLength = quill.getLength();
    // let range = { index: 0, length: textLength };

    // Get the entire content and iterate over each character
    for (let i = 0; i < textLength; i++) {
      const [link] = quill.getFormat(i, 1).link || [];
      if (link) {
        // Remove the link format only, leaving the text intact
        quill.formatText(i, 1, "link", false);
      }
    }

    this.setState({ showModal: false, url: "", text: "", isEditing: false });
  }

  async getDataBySlug(slug) {
  this.setState({ loading: true, showSpinner: true });

  let res = await DailyLogService.getDetails(slug);
  let list = res.data ? res.data : [];

  if (global.successStatus.includes(res.status) && list) {
    // Map all fields to state
    list.title = list.title || "";
    list.note = list.note || "";
    list.daily_log_slug = list.slug || "";
    list.full_name = list.user ? list.user.full_name : "";
    list.created_at = list.created_at || "";
    list.is_thread_enable = list.is_thread_enable || "";
    list.daily_log_thread = list.daily_log_thread || [];
    list.is_type = list.is_type || "";
    list.propertyName = list.property ? list.property.property_name : "";
    list.property_slug = list.property ? list.property.slug : "";
    list.dailyLogImages = list.images || [];

    let templateContent = {};
    if (typeof list.template_content === "string" && list.template_content) {
      try {
        templateContent = JSON.parse(list.template_content);
      } catch (e) { console.error(e); }
    } else if (list.template_content && typeof list.template_content === "object") {
      templateContent = list.template_content;
    }

    this.setState({
      ...list,
      templateData: templateContent,
      templateSections: templateContent.sections || [],
      originalTemplateSections: JSON.parse(JSON.stringify(templateContent.sections || [])),
      daily_log_thread_length: list.daily_log_thread.length,
    });
  }

  this.setState({ loading: false, showSpinner: false });
}

addnewdailylog = async () => {
  try {
    this.unblock && this.unblock();
    this.setState({ showAddNewdailylogConfirmModal: false });
    this.setState({ loading: true, showSpinner: true });
    const queryString = `property_slug=${this.state.property_slug}&request_type=1&create_date=${this.state.start_date}`;
    const response = await DailyLogService.checkDailyLogExists(queryString);
    this.setState({ loading: true, showSpinner: true });
    if (response.data.status_id != 1) {
      this.props.history.push({
        pathname: "/daily-log/add",
        state: {
          selectedProperty: this.state.selectedPropertyLog,
          selectedDate: this.state.filter_for_daily_log,
          slug: response.data.slug,
          isfromdetailpage: true,
          olddailylogslug: this.state.olddailylogslug
        
        }
    });
    }
    window.location.reload(false);
  } catch (err) {
    console.error("Error creating daily log:", err);
  }
};

async getDatabyfilter(event) {
  this.setState({ loading: true, showSpinner: true });
  const slug = this.state.property_slug;
  const selectedDate = new Date(event.target.value); 
  const start_date = Moment(event.target.value).format("YYYY-MM-DD");
  this.setState({filter_for_daily_log: selectedDate});
  if (this.state.property_slug && this.state.propertyName) {
    const selectedProperty = {value: this.state.property_slug, label: this.state.propertyName ? this.state.propertyName : ''};
    this.setState({ selectedPropertyLog: selectedProperty});
  }

  const queryString = `property_slug=${slug}&request_type=1&create_date=${start_date}&isfromdetaillog=1`;
  const response = await DailyLogService.checkDailyLogExists(queryString);
  this.setState({ popupContentForDetail: response.data.popupContentForDetail,});

  if (response.data) {
    if (response.data.status_id === 1 && response.data.ispastdailylog === 0) {
      // log exists → load existing log
      this.setState({ loading: false, showSpinner: false });
      await this.getDataBySlug(response.data.slug);
    } else if ((response.data.status_id === 1 && response.data.ispastdailylog === 1 ) || (response.data.status_id === 2 && response.data.ispastdailylog === 1 ) || (response.data.ispopupfordetailpage === 1 &&  response.data.ispastdailylog === 1)){
        this.setState({ loading: false, showSpinner: false });
        this.setState({
        showPastDatedailylogInfoModal: true,});
    } 
    else {
      this.setState({ loading: false, showSpinner: false });
      // log does NOT exist → show modal
      this.unblock && this.unblock(); 
      this.setState({
        showAddNewdailylogConfirmModal: true,
        showConfirmModal: false,
        start_date,     
        dailyLogSlug: response.data.slug,                          // save selected date
        confirmNavigation: () => {
          this.addnewdailylog();   
        }
      });
      
    }
  } else {
    console.warn("No response from server for daily log check");
  }
}

handleArrowClick = (direction) => {
  let { filter_for_daily_log, convert_created_at, selectedDate } = this.state;

  // Determine current selected date
  const currentDate =
    convert_created_at
      ? new Date(convert_created_at)
      : filter_for_daily_log
      ? new Date(filter_for_daily_log)
      : selectedDate
      ? new Date(selectedDate)
      : new Date();

  // Change date by direction (+1 or -1)
  const newDate = new Date(currentDate);
  newDate.setDate(currentDate.getDate() + direction);

  // Update using your existing handler
  this.getDatabyfilter({
    target: {
      type: "date",
      name: "filter_for_daily_log",
      value: newDate,
    },
  });
};

  async getData() {
    
    this.setState({ loading: true, showSpinner: true });
    let list = [];
    const slug =
      this.state.slug == "add" ? this.state.daily_log_slug : this.state.slug;
    let res = await DailyLogService.getDetails(slug);
    if (global.successStatus.includes(res.status)) {
      list = res.data ? res.data : [];
      list.title = list ? list.title : "";
      list.note = list ? list.note : "";
      list.daily_log_slug = list ? list.slug : "";
      list.full_name = list && list.user ? list.user.full_name : "";
      list.created_at = list ? list.created_at : "";
      list.is_thread_enable = list ? list.is_thread_enable : "";
      list.daily_log_thread = list ? list.daily_log_thread : [];
      list.is_type = list ? list.is_type : "";
      list.propertyName =
        list && list.property ? list.property.property_name : [];
      list.property_slug = list && list.property ? list.property.slug : "";
      list.dailyLogImages = list && list.images ? list.images : [];
      let templateContent = {};
      const rawContent = list.template_content;

      if (list.is_thread_enable !== 1) {
        this.setState({ isDisabled: true });
      }
      if (typeof rawContent === "string" && rawContent) {
        try {
          templateContent = JSON.parse(rawContent);
        } catch (e) {
          console.error("Failed to parse template content:", e);
        }
      } else if (rawContent && typeof rawContent === "object") {
        templateContent = rawContent;
      }
      
      this.setState({
        templateData: templateContent,
        templateSections: templateContent.sections || [],
         originalTemplateSections: JSON.parse(JSON.stringify(templateContent?.sections ?? [])),
         olddailylogslug: list.daily_log_slug,
      });
    }

    this.setState(list);
    let daily_log_thread_length =
      list && list.daily_log_thread ? list.daily_log_thread.length : 0;
    this.setState({ daily_log_thread_length: daily_log_thread_length });
    this.setState({ loading: false, showSpinner: false });
  }
  saveDailyLogs = async () => {
    // e.preventDefault();
    const {originalTemplateSections } = this.state;
    this.setState({
      alertModalMessage: "",
      loading: true,
      isSubmit: true,
    });

    if (this.validator.allValid() && this.customValidate()) {
      try {
        let sectionsWithFlag = [];

        if (!this.state.templateSections || this.state.templateSections.length === 0) {
          window.location.replace(window.location.pathname);
          return; // stop execution
        }

        if (originalTemplateSections && Array.isArray(originalTemplateSections)) {
          sectionsWithFlag = this.state.templateSections.map((section, index) => {
            const originalSection = originalTemplateSections[index];

            // Default section update flag
            let isUpdated =
              JSON.stringify(section.inputs) !== JSON.stringify(originalSection.inputs) ||
              JSON.stringify(section.entries) !== JSON.stringify(originalSection.entries) ||
              JSON.stringify(section.logs) !== JSON.stringify(originalSection.logs) ||
              JSON.stringify(section.tasks) !== JSON.stringify(originalSection.tasks)
                ? 1
                : 0;

            // Clone section so we can add category-level flags
            let newSection = { ...section, isSectionUpdated: isUpdated };

            // Add "isLogSectionUpdated" per category if it's a log_entries section
            if (section.section_type === "log_entries" && section.logs) {
              const newLogs = {};
              Object.keys(section.logs).forEach((category) => {
                const newCategoryData = section.logs[category] || { entries: [] };
                const originalCategoryData =
                  (originalSection.logs && originalSection.logs[category]) || { entries: [] };

                // Compare category entries
                const isLogSectionUpdated =
                  JSON.stringify(newCategoryData.entries) !==
                  JSON.stringify(originalCategoryData.entries)
                    ? 1
                    : 0;

                newLogs[category] = {
                  ...newCategoryData,
                  isLogSectionUpdated: isLogSectionUpdated, // <-- new flag per category
                };

                // If any log category updated, mark section updated as well
                if (isLogSectionUpdated) {
                  newSection.isSectionUpdated = 1;
                }
              });

              newSection.logs = newLogs;
            }

            return newSection;
          });
        } else {
          sectionsWithFlag = this.state.templateSections;
        }
        if (!this.hasSingleLogEntriesSection(this.state.templateSections)) {
        window.location.reload();
        return;
        }
     
        const templateContent = {
          template_name: "Daily Operation Log",
          template_type: "template",
          sections: sectionsWithFlag,
        };

        let inputData = {
          title: this.state.title,
          note: this.state.note,
          property_slug: this.state.property_slug,
          request_type: 2,
          daily_log_slug:
            this.props.location?.state?.slug || this.state.daily_log_slug,
          template_content: JSON.stringify(templateContent),
          history: this.state.slug === "add" ? 1 : 2,
        };

        let res = await DailyLogService.createDailyLog(inputData);
        let resSlug = res?.data?.slug;

        if (global.successStatus.includes(res.status)) {
          this.setState(
            {
              daily_log_slug: resSlug,
              showAlertModal: true,
              alertModalType: "success",
              alertModalTitle: "Success",
              slug: resSlug,
              daily_log_title: "",
              daily_log_note: "",
              isSubmit: false,
              loading: false,
              alertModalMessage: res.message || "Success",
              hasUnsavedChanges: false,
            },
            () => {
              // Auto-hide after 2 seconds
              setTimeout(() => {
                this.setState({ showAlertModal: false });
              }, 2000);
            }
          );

          setTimeout(
            () => this.props.history.push("/daily-log/" + resSlug),
            global.redirect_time
          );
          setTimeout(
            () => this.setState({ showAlertModal: false }),
            global.redirect_time
          );

          this.getData();
          this.getVersion();
        } else {
          this.setState({
            showAlertModal: true,
            alertModalType: "error",
            alertModalTitle: "Error!",
            alertModalMessage: res?.message,
            loading: false,
            isSubmit: false,
          });
          window.location.replace(window.location.pathname);
          throw res; // go to catch block
        }
      } catch (res) {
        window.location.replace(window.location.pathname);
        let alertMessage = res?.data?.message || "Something went wrong.";
        let errors = {};

        if (res?.data?.result?.errorDetail?.length) {
          res.data.result.errorDetail.forEach((item) => {
            errors[item.errorField] = item.errorMessage?.[0] || "Invalid value";
          });
        }

        this.setState({
          errors,
          showAlertModal: true,
          alertModalType: "error",
          alertModalTitle: "Error!",
          alertModalMessage: alertMessage,
          loading: false,
          isSubmit: false,
        });

        setTimeout(() => {
          this.setState({
            showAlertModal: false,
          });
        }, global.alert_close_time);
      }
    } else {
      this.validator.showMessages();
      this.setState({
        showAlertModal: true,
        alertModalType: "error",
        alertModalTitle: "Validation Error!",
        alertModalMessage: "Please fill all required fields correctly.",
        loading: false,
        isSubmit: false,
      });

      setTimeout(() => {
        this.setState({ showAlertModal: false });
      }, global.alert_close_time);
    }
  };

  saveSection = async (sectionIndex) => {
    this.setState({
      alertModalMessage: "",
      loading: true,
      isSubmit: true,
    });
    if (!this.hasSingleLogEntriesSection(this.state.templateSections)) {
       window.location.reload();
      return;
    }

    try {
      const templateContent = {
        template_name: "Daily Operation Log",
        template_type: "template",
        sections: this.state.templateSections,
      };

      let inputData = {
        title: this.state.title,
        note: this.state.note,
        property_slug: this.state.property_slug,
        daily_log_slug:
          this.props.location?.state?.slug || this.state.daily_log_slug,
        template_content: JSON.stringify(templateContent),
        section_index: sectionIndex,
        request_type: 2,
        history: 1,
      };

      let res = await DailyLogService.createDailyLog(inputData);
      let resSlug = res?.data?.slug;

      if (global.successStatus.includes(res.status)) {
        this.setState({
          daily_log_slug: resSlug,
          showAlertModal: true,
          alertModalType: "success",
          alertModalTitle: "Success",
          isSubmit: false,
          loading: false,
          alertModalMessage: "Section saved successfully!",
          hasUnsavedChanges: false,
        });
        setTimeout(() => {
          this.setState({ showAlertModal: false });
        }, global.alert_close_time);
        this.getTemplate();
      } else {
        throw res; // go to catch block
      }
    } catch (res) {
      let alertMessage = res?.data?.message || "Something went wrong.";
      let errors = {};

      if (res?.data?.result?.errorDetail?.length) {
        res.data.result.errorDetail.forEach((item) => {
          errors[item.errorField] = item.errorMessage?.[0] || "Invalid value";
        });
      }

      this.setState({
        errors,
        showAlertModal: true,
        alertModalType: "error",
        alertModalTitle: "Error!",
        alertModalMessage: alertMessage,
        loading: false,
        isSubmit: false,
      });

      setTimeout(() => {
        this.setState({
          showAlertModal: false,
        });
      }, global.alert_close_time);
    }
  };
  hasSingleLogEntriesSection = (sections) => {
    if (!Array.isArray(sections)) return false;
    // Count how many sections have section_type === "log_entries"
    const count = sections.filter(sec => sec.section_type === "log_entries").length;
    // Return true only if exactly one exists
    return count === 1;
  };



  saveDailyLogThread = async () => {
    const { deletedImages, templateSections } = this.state;

    // 1. Filter out deleted images from all entries
    const updatedSections = templateSections.map((section) => {
      if (section.section_type === "log_entries") {
        const updatedLogs = {};

        Object.keys(section.logs || {}).forEach((category) => {
          updatedLogs[category] = {
            entries: section.logs[category].entries.map((entry) => ({
              ...entry,
              images:
                entry.images?.filter(
                  (img) => !deletedImages.includes(img.slug)
                ) || [],
            })),
          };
        });

        return { ...section, logs: updatedLogs };
      }
      return section;
    });

    // 2. Prepare data for API
    const inputData = {
      title: this.state.currentLogCategory,
      comment: this.state.newLogEntry,
      daily_log_slug:
        this.props.location?.state?.slug || this.state.daily_log_slug,
      daily_log_thread_slug: this.state.daily_log_thread_slug,
      deleted_images: deletedImages, // Send to backend
      template_content: JSON.stringify({
        template_name: "Daily Operation Log",
        template_type: "template",
        sections: updatedSections,
      }),
    };
    if (!this.hasSingleLogEntriesSection(updatedSections)) {
       window.location.reload();
      return;
    }
 
    try {
      this.setState({ loading: true });
      const res = await DailyLogService.createDailyLogThread(inputData);

      if (global.successStatus.includes(res.status)) {
        // 3. On success, update state and clear deleted images
        this.setState({
          templateSections: updatedSections,
          deletedImages: [], // Clear the deleted images list
          loading: false,
          showAlertModal: true,
          alertModalType: "success",
          alertModalMessage: "Changes saved successfully",
        });
        setTimeout(() => {
          this.setState({ showAlertModal: false });
        }, global.alert_close_time);
        return res.data;
      }
      throw new Error(res.message || "Failed to save");
    } catch (error) {
      this.setState({
        loading: false,
        showAlertModal: true,
        alertModalType: "error",
        alertModalMessage: error.message,
      });
      throw error;
    }
  };

  saveDailyLogReply = async () => {
    const { replyDeletedImages, templateSections } = this.state;

    // 1. Filter out deleted images from all replies
    const updatedSections = templateSections.map((section) => {
      if (section.section_type === "log_entries") {
        const updatedLogs = {};

        Object.keys(section.logs || {}).forEach((category) => {
          updatedLogs[category] = {
            entries: section.logs[category].entries.map((entry) => ({
              ...entry,
              replies:
                entry.replies?.map((reply) => ({
                  ...reply,
                  images:
                    reply.images?.filter(
                      (img) => !replyDeletedImages.includes(img.slug)
                    ) || [],
                })) || [],
            })),
          };
        });

        return { ...section, logs: updatedLogs };
      }
      return section;
    });

    // 2. Prepare data for API
    const inputData = {
      category: this.state.currentReplyCategory,
      reply: this.state.newReply,
      daily_log_slug: this.props.location?.state?.slug
        ? this.props.location.state.slug
        : this.state.daily_log_slug,
      daily_log_thread_slug: this.state.daily_log_thread_slug
        ? this.state.daily_log_thread_slug
        : "",
      daily_log_replies_slug: this.state.daily_log_replies_slug
        ? this.state.daily_log_replies_slug
        : "",
      deleted_images: replyDeletedImages, // Send deleted images to backend
      template_content: JSON.stringify({
        template_name: "Daily Operation Log",
        template_type: "template",
        sections: updatedSections,
      }),
    };

    try {
      this.setState({ loading: true });
      const res = await DailyLogService.createDailyLogThreadReply(inputData);

      if (global.successStatus.includes(res.status)) {
        let resDataSlug = res.data ? res.data?.slug : "";
        let resCreatedAt = res.data ? res.data?.created_at : "";

        // 3. On success, update state and clear deleted images
        this.setState({
          templateSections: updatedSections,
          replyDeletedImages: [], // Clear the deleted images list
          daily_log_thread_slug: resDataSlug,
          loading: false,
          showAlertModal: true,
          alertModalType: "success",
          alertModalMessage: res.message ? res.message : "Success",
        });

        setTimeout(() => {
          this.setState({ showAlertModal: false });
        }, global.alert_close_time);

        return { slug: resDataSlug, created_at: resCreatedAt };
      } else {
        let alertMessage = "";
        if (res.data.result.errorDetail !== null) {
          let errors = {};
          res.data.errorCode = "Validation Failed";
          res.data.result.errorDetail.forEach((item) => {
            errors[item.errorField] = item.errorMessage[0];
            res.data.errorMessage = "";
          });
          this.setState({ errors: errors });
        }
        this.setState({
          showAlertModal: true,
          alertModalType: "error",
          alertModalTitle: res.data.message ? res.data.message : "Error!",
          alertModalMessage:
            alertMessage !== "" ? alertMessage : res.data.message,
          loading: false,
        });

        setTimeout(() => {
          this.setState({ showAlertModal: false });
        }, global.alert_close_time);
        throw new Error(res.message || "Failed to save reply");
      }
    } catch (error) {
      this.setState({
        loading: false,
        showAlertModal: true,
        alertModalType: "error",
        alertModalMessage: error.message,
      });
      throw error;
    }
  };

  async deleteImage(slug) {
    this.setState({ loading: true, isSubmit: true });

    try {
      let res = await ActionItemService.deleteImage(slug);

      if (global.successStatus.includes(res.status)) {
        // Remove the image from all relevant state locations
        this.setState((prevState) => {
          // 1. Remove from dailyLogImages
          const updatedDailyLogImages = prevState.dailyLogImages.filter(
            (img) => img.slug !== slug
          );

          // 2. Remove from templateSections (log entries)
          const updatedTemplateSections = prevState.templateSections.map(
            (section) => {
              if (section.section_type === "log_entries") {
                const updatedLogs = {};

                // Iterate through all categories
                Object.keys(section.logs || {}).forEach((category) => {
                  // Filter out the image from all entries in this category
                  updatedLogs[category] = {
                    entries: section.logs[category].entries.map((entry) => ({
                      ...entry,
                      images:
                        entry.images?.filter((img) => img.slug !== slug) || [],
                    })),
                  };
                });

                return {
                  ...section,
                  logs: updatedLogs,
                };
              }
              return section;
            }
          );

          // 3. Update the templateData to match
          const updatedTemplateData = {
            ...prevState.templateData,
            sections: updatedTemplateSections,
          };

          return {
            dailyLogImages: updatedDailyLogImages,
            templateSections: updatedTemplateSections,
            templateData: updatedTemplateData,
            showAlertModal: true,
            alertModalType: "success",
            alertModalTitle: "Success",
            alertModalMessage: res.message || "Image deleted successfully",
            showModalImage: false,
            loading: false,
            isSubmit: false,
          };
        });
      } else {
        throw new Error(res.message || "Failed to delete image");
      }
    } catch (error) {
      this.setState({
        loading: false,
        isSubmit: false,
        showAlertModal: true,
        alertModalType: "error",
        alertModalTitle: "Error!",
        alertModalMessage: error.message,
      });
    }

    setTimeout(
      () => this.setState({ showAlertModal: false }),
      global.alert_close_time
    );
  }

  deleteReplyImage = async (slug) => {
    this.setState({ loading: true, isSubmit: true });

    try {
      let res = await ActionItemService.deleteImage(slug);

      if (global.successStatus.includes(res.status)) {
        // Remove the image from reply images in template sections
        this.setState((prevState) => {
          const newSections = [...prevState.templateSections];
          const logSection = newSections.find(
            (s) => s.section_type === "log_entries"
          );

          if (logSection && logSection.logs) {
            // Iterate through all categories and entries to find and remove the image
            Object.keys(logSection.logs).forEach((category) => {
              if (
                logSection.logs[category] &&
                logSection.logs[category].entries
              ) {
                logSection.logs[category].entries.forEach((entry) => {
                  if (entry.replies && entry.replies.length) {
                    entry.replies.forEach((reply) => {
                      if (reply.images && reply.images.length) {
                        reply.images = reply.images.filter(
                          (img) => img.slug !== slug
                        );
                      }
                    });
                  }
                });
              }
            });
          }

          return {
            templateSections: newSections,
            showAlertModal: true,
            alertModalType: "success",
            alertModalTitle: "Success",
            alertModalMessage:
              res.message || "Reply image deleted successfully",
            showModalImage: false,
            loading: false,
            isSubmit: false,
          };
        });
      } else {
        throw new Error(res.message || "Failed to delete reply image");
      }
    } catch (error) {
      this.setState({
        loading: false,
        isSubmit: false,
        showAlertModal: true,
        alertModalType: "error",
        alertModalTitle: "Error!",
        alertModalMessage: error.message,
      });
    }

    setTimeout(
      () => this.setState({ showAlertModal: false }),
      global.alert_close_time
    );
  };

  openModal(data) {
    this.setState({
      addModal: true,
      showAlertModal: false,
      errors: {},
      templateShow: true,
    });
    if (this.state.is_type === 1) {
      setTimeout(() => {
        this.nameInput.focus();
      }, 0);
    }
  }

  // Get Property List
  async getPropertyList(queryString = "") {
    this.setState({ loading: true });
    var propertyList = [];
    var propertyListData = [];
    let res = await PropertyService.getPropertyList(
      "is_dropdown=1" + (queryString ? "&" + queryString : "")
    );
    if (global.successStatus.includes(res.status)) {
      propertyList = res.data ? res.data : [];
    }
    propertyList.forEach((item) => {
      propertyListData.push({
        label: item.property_name,
        value: item.slug,
      });
    });
    if (propertyList.length === 1) {
      this.setState({
        propertyList: propertyListData,
        propertyNameDrop: propertyList[0].property_name, // Set single property name
        property_slug: propertyList[0].slug, // Set single property slug
      });
    } else {
      this.setState({
        propertyList: propertyListData,
      });
    }
    this.setState({ loading: false });
  }

  async getTemplate(queryString = "") {
    this.setState({ loading: true });
    let list = [];
    try {
      // Add property_slug to query string if available
      const propertySlug = this.state.property_slug || (this.props.location.state?.selectedProperty?.value);
      queryString = `daily_log_slug=${
        this.props.location.state.slug
          ? this.props.location.state.slug
          : this.state.daily_log_slug
      }${propertySlug ? `&property_slug=${propertySlug}` : ""}`;
      const res = await DailyLogService.DailyLogTemplate(queryString);
      if (global.successStatus.includes(res.status)) {
        list = res.data ? res.data : [];
        list.is_thread_enable = list.is_thread_enable || 2;
        let templateContent = {};
        const rawContent = list.template_content;

        if (typeof rawContent === "string" && rawContent) {
          try {
            templateContent = JSON.parse(rawContent);
          } catch (e) {
            console.error("Failed to parse template content:", e);
          }
        } else if (rawContent && typeof rawContent === "object") {
          templateContent = rawContent;
        }
        this.setState({
          templateData: templateContent,
          templateSections: templateContent.sections || [],
        });
        this.setState({ is_thread_enable: list.is_thread_enable });
      } else {
        console.log("Error fetching template:", res.message);
      }
    } catch (error) {
      console.error("Error parsing template:", error);
    }
    this.setState({ loading: false });
  }

  async getVersion(queryString = "") {
    this.setState({ loading: true });
    try {
      queryString = `daily_log_slug=${this.state.slug}`;
      const res = await DailyLogService.DailyLogVersion(queryString);
      if (global.successStatus.includes(res.status)) {
        const versions = res.data ? res.data : [];
        this.setState({ versions });
      }
    } catch (error) {
      console.error("Error fetching versions:", error);
    }
    this.setState({ loading: false });
  }

  showVersionHistory = async () => {
    this.setState((prevState) => ({
      showVersionHistory: !prevState.showVersionHistory,
      selectedVersion:
        !prevState.showVersionHistory && this.state.versions.length > 0
          ? this.state.versions[0]
          : null,
      isViewMode: true,
    }));
  };
  /* Image close */
  deleteLogEntryImage = async (index) => {
    this.setState((prevState) => {
      const image = prevState.logEntryImages[index];
      const newImages = [...prevState.logEntryImages];
      const newDeletedImages = [...prevState.deletedImages];

      // If image has a slug (already uploaded), add to deletedImages
      if (image && image.slug) {
        newDeletedImages.push(image.slug);
      }

      // Remove image from display
      newImages.splice(index, 1);

      return {
        logEntryImages: newImages,
        deletedImages: newDeletedImages,
      };
    });
  };

  handleImageUpload = async (event) => {
    const files = event.target.files;
    this.setState({ isLoading: true });
    // Validate total images
    if (this.state.logEntryImages.length + files.length > 10) {
      this.setState({
        error: "You can only upload a maximum of 10 images.",
      });
      event.target.value = ""; // Reset the file input
      return;
    }

    this.setState({ isLoading: true });
    const newImages = [];

    try {
      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        const fileSize = file.size;
        const options = {
          maxSizeMB: 1, // Maximum file size to 1MB
          maxWidthOrHeight: 1920, // Maximum dimension
          useWebWorker: true, // Use web worker for better performance
        };

        let processedFile = file;

        // Compress the image if it's larger than 2MB
        if (fileSize >= 2e6) {
          try {
            processedFile = await imageCompression(file, options);
          } catch (error) {
            console.error("Error compressing image:", error);
            // Fallback to original file if compression fails
            processedFile = file;
          }
        }

        newImages.push({
          file: processedFile,
          src: URL.createObjectURL(processedFile),
          id: Date.now() + i,
          isUploaded: false,
          originalFile: file, // Keep reference to original file
          isCompressed: fileSize >= 2e6, // Flag if compressed
        });
      }
      this.setState((prevState) => ({
        logEntryImages: [...prevState.logEntryImages, ...newImages],
        arrAllImages: [...prevState.arrAllImages, ...newImages],
        error: "",
        isLoading: false,
      }));
    } catch (error) {
      console.error("Error processing images:", error);
      this.setState({
        error: "Error processing images. Please try again.",
        isLoading: false,
      });
    }
  };

  async getImageForUpload(slug) {
    // Filter out already uploaded images
    const imagesToUpload = this.state.arrAllImages.filter(
      (img) => !img.isUploaded
    );

    if (imagesToUpload.length > 0) {
      // Create an array of upload promises
      const uploadPromises = imagesToUpload.map((image) =>
        this.onImageUpload(image, slug)
      );

      try {
        // Wait for all uploads to complete
        await Promise.all(uploadPromises);

        // Update state to mark images as uploaded
        this.setState((prevState) => ({
          arrAllImages: prevState.arrAllImages.map((img) =>
            imagesToUpload.some((uploadedImg) => uploadedImg.id === img.id)
              ? { ...img, isUploaded: true }
              : img
          ),
          logEntryImages: prevState.logEntryImages.map((img) =>
            imagesToUpload.some((uploadedImg) => uploadedImg.id === img.id)
              ? { ...img, isUploaded: true }
              : img
          ),
        }));
      } catch (error) {
        console.error("Error uploading images:", error);
      }
    }
  }

  onImageUpload = async (image, slug, index, context = "thread") => {
    // Skip if already uploaded
    this.setState({ loading: true });
    if (image.isUploaded) return;

    try {
      const fileData = new FormData();
      fileData.append("file_name", image.file, image.file.name);

      // Determine context - reply or thread
      if (context === "reply") {
        fileData.append("daily_log_reply_slug", slug);
        fileData.append("is_daily_log_reply", 2);
        fileData.append("refTableId", 8);
      } else {
        fileData.append("daily_log_thread_slug", slug);
        fileData.append("is_daily_log_thread", 1);
        fileData.append("refTableId", 7);
      }

      let res = await AuditService.uploadInspFile(fileData);

      if (global.successStatus.includes(res.status)) {
        this.setState({ loading: false });
        return {
          ...image,
          isUploaded: true,
          serverData: res.data,
          slug: res.data?.slug,
          filePath: res.data.filePath,
        };
      } else if (res.status === 413) {
        this.setState({
          loading: false,
          showAlertModal: true,
          alertModalType: "error",
          alertModalTitle: "Error!",
          alertModalMessage: "Content Too Large",
        });
      } else {
        let alertMessage = "";
        if (res.data.result.errorDetail !== null) {
          let errors = {};
          res.data.errorCode = "Validation Failed";
          res.data.result.errorDetail.forEach((item) => {
            errors[item.errorField] = item.errorMessage[0];
            res.data.errorMessage = "";
          });
          this.setState({ errors: errors });
        }
        this.setState({
          showSpinner: false,
          showAlertModal: true,
          alertModalType: "error",
          alertModalTitle: res.data.errorCode ? res.data.errorCode : "Error!",
          alertModalMessage:
            alertMessage !== "" ? alertMessage : res.data.message,
        });
      }
    } catch (error) {
      this.setState({
        loading: false,
        showAlertModal: true,
        alertModalType: "error",
        alertModalTitle: "Error!",
        alertModalMessage: "An error occurred while processing the image.",
      });
      throw error;
    }
  };

  toggleSection = (sectionIndex) => {
    this.setState((prevState) => {
      const prevCollapsed = prevState.collapsedSections[sectionIndex];
      // If undefined (first time), set to false (expand)
      const newCollapsed = prevCollapsed === undefined ? false : !prevCollapsed;
      return {
        collapsedSections: {
          ...prevState.collapsedSections,
          [sectionIndex]: newCollapsed,
        },
      };
    });
  };

  renderSection(section, sectionIndex) {
    switch (section.section_type) {
      case "staff":
        return this.renderStaffSection(section, sectionIndex);
      case "key_staff":
        return this.renderKeyStaffSection(section, sectionIndex);
      case "scores":
        return this.renderScoreSection(section, sectionIndex);
      case "fnb_results":
        return this.renderFnbSection(section, sectionIndex);
      case "sales":
        return this.renderSalesSection(section, sectionIndex);
      case "forward_looking":
        return this.renderForwardSection(section, sectionIndex);
      case "tasks":
      case "calendar":
        return this.renderTasksSection(section, sectionIndex);
      case "log_entries":
        return this.renderLogEntriesSection(section, sectionIndex);
      default:
        return null;
    }
  }

  renderSectionHeader(section, sectionIndex) {
    const isSaving = this.state.savingSection === sectionIndex;
    return (
      <>
        {this.state.is_thread_enable === 1 && (
          <button
            type="button"
            className="gf-primary-btn-small-one mr-2 btn-sm"
            disabled={isSaving}
            onClick={(e) => {
              e.stopPropagation();
              this.setState({ savingSection: sectionIndex }); // Set currently saving section

              const savePromise =
                this.state.slug === "add"
                  ? this.saveSection(sectionIndex)
                  : this.saveDailyLogs(e);

              Promise.resolve(savePromise).finally(() => {
                this.setState({ savingSection: null }); // Reset after save completes
              });
            }}
          >
            {isSaving ? global.loader : "Update"}
          </button>
        )}
      </>
    );
  }

  renderStaffSection(section, sectionIndex) {
    const isCollapsed = this.state.collapsedSections[sectionIndex] ?? true;

    return (
      <div className="pd-t-0 pd-b-0 pd-l-70 pd-r-70" key={sectionIndex}>
        <div key={`staff-${sectionIndex}`} className="mb-4 border-bottom pb-3">
          <div
            className="d-flex justify-content-between align-items-center cursor-pointer"
            onClick={() => this.toggleSection(sectionIndex)}
            style={{ cursor: "pointer" }}
          >
            <h3 className="mb-0 text-uppercase">
              {section.table_tag}
              {section.inputs.some((input) =>
                section.columns.some((column) => input[column.column_name])
              ) && <span className="change-daily-log-dot"></span>}
            </h3>
            <div className="d-flex align-items-center">
              {/* <div className={`visible ${isCollapsed ? 'd-none' : 'd-flex'}`}>
              {this.renderSectionHeader(section, sectionIndex)}
              </div> */}
              <span className="Collapsible-arrow log-arrow c-gray-color">
                <i
                  className={`fa fa-angle-${isCollapsed ? "down" : "up"} fs-4`}
                ></i>
              </span>
            </div>
          </div>

          <div className={`collapse ${!isCollapsed ? "show" : ""}`}>
            <section className="card mt-2">
              <div className="table-responsive">
                <table className="table no-wrap mg-b-30 pd-b-2">
                  <thead>
                    <tr>
                      {section.columns.map((column, colIndex) => (
                        <th key={`staff-col-${colIndex}`}>
                          {column.column_name}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {section.inputs.map((input, inputIndex) => (
                      <tr key={`staff-row-${inputIndex}`}>
                        {section.columns.map((column, colIndex) => (
                          <td key={`staff-cell-${colIndex}`}>
                            <input
                              type="text"
                              className="form-control"
                              value={input[column.column_name] || ""}
                              disabled={this.state.isDisabled}
                              onChange={(e) =>
                                this.handleTemplateChange(
                                  sectionIndex,
                                  `inputs.${inputIndex}.${column.column_name}`,
                                  e.target.value
                                )
                              }
                            />
                          </td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </section>
          </div>
        </div>
      </div>
    );
  }

  renderKeyStaffSection(section, sectionIndex) {
    const isCollapsed = this.state.collapsedSections[sectionIndex] ?? true;

    return (
      <div className="pd-t-0 pd-b-0 pd-l-70 pd-r-70" key={sectionIndex}>
        <div
          key={`key-staff-${sectionIndex}`}
          className="mb-4 border-bottom pb-3"
        >
          <div
            className="d-flex justify-content-between align-items-center cursor-pointer"
            onClick={() => this.toggleSection(sectionIndex)}
            style={{ cursor: "pointer" }}
          >
            <h3 className="mb-0 text-uppercase">
              {section.table_tag}
              {section.inputs.some((input) =>
                section.columns.some((column) => input[column.column_name])
              ) && <span className="change-daily-log-dot"></span>}
            </h3>
            <div className="d-flex align-items-center">
              {/* <div className={`visible ${isCollapsed ? 'd-none' : 'd-flex'}`}>
                {this.renderSectionHeader(section, sectionIndex)}
              </div> */}
              <span className="Collapsible-arrow log-arrow c-gray-color">
                <i
                  className={`fa fa-angle-${isCollapsed ? "down" : "up"} fs-4`}
                ></i>
              </span>
            </div>
          </div>

          <div className={`collapse ${!isCollapsed ? "show" : ""}`}>
            <div className="table-responsive mt-2">
              <table className="table no-wrap mg-b-30 pd-b-2">
                <thead>
                  <tr>
                    <th></th>
                    {section.columns.map((column, colIndex) => (
                      <th key={`key-staff-col-${colIndex}`}>
                        {column.column_name}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {section.inputs.map((input, inputIndex) => (
                    <tr key={`key-staff-row-${input.row_id}`}>
                      <td>{input.row_title}</td>
                      {section.columns.map((column, colIndex) => (
                        <td key={`key-staff-cell-${colIndex}`}>
                          <input
                            type="text"
                            className="form-control"
                            value={input[column.column_name] || ""}
                            disabled={this.state.isDisabled}
                            onChange={(e) =>
                              this.handleTemplateChange(
                                sectionIndex,
                                `inputs.${inputIndex}.${column.column_name}`,
                                e.target.value
                              )
                            }
                          />
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderScoreSection(section, sectionIndex) {
    const isCollapsed = this.state.collapsedSections[sectionIndex] ?? true;

    return (
      <div className="pd-t-0 pd-b-0 pd-l-70 pd-r-70" key={sectionIndex}>
        <div key={`scores-${sectionIndex}`} className="mb-4 border-bottom pb-3">
          <div
            className="d-flex justify-content-between align-items-center cursor-pointer"
            onClick={() => this.toggleSection(sectionIndex)}
            style={{ cursor: "pointer" }}
          >
            <h3 className="mb-0 text-uppercase">
              {section.table_tag}
              {section.inputs.some((input) =>
                section.columns.some((column) => input[column.column_name])
              ) && <span className="change-daily-log-dot"></span>}
            </h3>
            <div className="d-flex align-items-center">
              <span className="Collapsible-arrow log-arrow c-gray-color">
                <i
                  className={`fa fa-angle-${isCollapsed ? "down" : "up"} fs-4`}
                ></i>
              </span>
            </div>
          </div>

          <div className={`collapse ${!isCollapsed ? "show" : ""}`}>
            <div className="table-responsive mt-2">
              <table className="table no-wrap mg-b-30 pd-b-2">
                <thead>
                  <tr>
                    <th></th>
                    {section.columns.map((col, i) => (
                      <th key={`score-col-${i}`}>{col.column_name}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {section.inputs.map((input, inputIndex) => (
                    <tr key={`score-row-${input.row_id}`}>
                      <td>{input.row_title}</td>
                      {input.row_title ===
                      "Score Status (Green | Red | Yellow)" ? (
                        <td colSpan={section.columns.length}>
                          <input
                            type="text"
                            className="form-control"
                            value={input[section.columns[0].column_name] || ""}
                            disabled={this.state.isDisabled}
                            onChange={(e) =>
                              this.handleTemplateChange(
                                sectionIndex,
                                `inputs.${inputIndex}.${section.columns[0].column_name}`,
                                e.target.value
                              )
                            }
                          />
                        </td>
                      ) : (
                        section.columns.map((column, colIndex) => (
                          <td key={`score-cell-${colIndex}`}>
                            <input
                              type="text"
                              className="form-control"
                              value={input[column.column_name] || ""}
                              disabled={this.state.isDisabled}
                              onChange={(e) =>
                                this.handleTemplateChange(
                                  sectionIndex,
                                  `inputs.${inputIndex}.${column.column_name}`,
                                  e.target.value
                                )
                              }
                            />
                          </td>
                        ))
                      )}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderFnbSection(section, sectionIndex) {
    const isCollapsed = this.state.collapsedSections[sectionIndex] ?? true;

    return (
      <div className="pd-t-0 pd-b-0 pd-l-70 pd-r-70" key={sectionIndex}>
        <div key={`fnb-${sectionIndex}`} className="mb-4 border-bottom pb-3">
          <div
            className="d-flex justify-content-between align-items-center cursor-pointer"
            onClick={() => this.toggleSection(sectionIndex)}
            style={{ cursor: "pointer" }}
          >
            <h3 className="mb-0 text-uppercase">
              {section.table_tag}
              {section.inputs.some((input) =>
                section.columns.some((column) => input[column.column_name])
              ) && <span className="change-daily-log-dot"></span>}
            </h3>
            <div className="d-flex align-items-center">
              {/* <div className={`visible ${isCollapsed ? 'd-none' : 'd-flex'}`}>
              {this.renderSectionHeader(section, sectionIndex)}
              </div> */}
              <span className="Collapsible-arrow log-arrow c-gray-color">
                <i
                  className={`fa fa-angle-${isCollapsed ? "down" : "up"} fs-4`}
                ></i>
              </span>
            </div>
          </div>

          <div className={`collapse ${!isCollapsed ? "show" : ""}`}>
            <div className="table-responsive mt-2">
              <table className="table no-wrap mg-b-30 pd-b-2">
                <thead>
                  <tr>
                    <th></th>
                     {section.columns.map((column, colIndex) => (
                      <th key={`fnb-col-${colIndex}`}>
                        {column.column_name}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  

                  {section.inputs.map((input, inputIndex) => (
                    <tr key={`fnb-row-${input.row_id}`}>
                      <td>{input.row_title}</td>
                      {section.columns.map((column, colIndex) => (
                        <td key={`fnb-cell-${colIndex}`}>
                          <input
                            type="text"
                            className="form-control"
                            value={input[column.column_name] || ""}
                            disabled={this.state.isDisabled}
                            onChange={(e) =>
                              this.handleTemplateChange(
                                sectionIndex,
                                `inputs.${inputIndex}.${column.column_name}`,
                                e.target.value
                              )
                            }
                          />
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderSalesSection(section, sectionIndex) {
    const isCollapsed = this.state.collapsedSections[sectionIndex] ?? true;

    return (
      <div className="pd-t-0 pd-b-0 pd-l-70 pd-r-70" key={sectionIndex}>
        <div key={`sales-${sectionIndex}`} className="mb-4 border-bottom pb-3">
          <div
            className="d-flex justify-content-between align-items-center cursor-pointer"
            onClick={() => this.toggleSection(sectionIndex)}
            style={{ cursor: "pointer" }}
          >
            <h3 className="mb-0 text-uppercase">
              {section.table_tag}
              {section.inputs.some((input) =>
                section.columns.some((column) => input[column.column_name])
              ) && <span className="change-daily-log-dot"></span>}
            </h3>
            <div className="d-flex align-items-center">
              {/* <div className={`visible ${isCollapsed ? 'd-none' : 'd-flex'}`}>
                {this.renderSectionHeader(section, sectionIndex)}
              </div> */}
              <span className="Collapsible-arrow log-arrow c-gray-color">
                <i
                  className={`fa fa-angle-${isCollapsed ? "down" : "up"} fs-4`}
                ></i>
              </span>
            </div>
          </div>

          <div className={`collapse ${!isCollapsed ? "show" : ""}`}>
            <div className="table-responsive mt-2">
              <table className="table no-wrap mg-b-30 pd-b-2">
                <thead>
                  <tr>
                    <th></th>
                    {section.columns.map((column, colIndex) => (
                      <th key={`sales-col-${colIndex}`}>
                        {column.column_name}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {section.inputs.map((input, inputIndex) => (
                    <tr key={`sales-row-${input.row_id}`}>
                      <td>{input.row_title}</td>
                      {section.columns.map((column, colIndex) => (
                        <td key={`sales-cell-${colIndex}`}>
                          <input
                            type="text"
                            className="form-control"
                            value={input[column.column_name] || ""}
                            disabled={this.state.isDisabled}
                            onChange={(e) =>
                              this.handleTemplateChange(
                                sectionIndex,
                                `inputs.${inputIndex}.${column.column_name}`,
                                e.target.value
                              )
                            }
                          />
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderForwardSection(section, sectionIndex) {
    const isCollapsed = this.state.collapsedSections[sectionIndex] ?? true;

    return (
      <div className="pd-t-0 pd-b-0 pd-l-70 pd-r-70" key={sectionIndex}>
        <div
          key={`forward-${sectionIndex}`}
          className="mb-4 border-bottom pb-3"
        >
          <div
            className="d-flex justify-content-between align-items-center cursor-pointer"
            onClick={() => this.toggleSection(sectionIndex)}
            style={{ cursor: "pointer" }}
          >
            <h3 className="mb-0 text-uppercase">
              {section.table_tag}
              {section.inputs.some((input) =>
                section.columns.some((column) => input[column.column_name])
              ) && <span className="change-daily-log-dot"></span>}
            </h3>
            <div className="d-flex align-items-center">
              {/* <div className={`visible ${isCollapsed ? 'd-none' : 'd-flex'}`}>
                {this.renderSectionHeader(section, sectionIndex)}
              </div> */}
              <span className="Collapsible-arrow log-arrow c-gray-color">
                <i
                  className={`fa fa-angle-${isCollapsed ? "down" : "up"} fs-4`}
                ></i>
              </span>
            </div>
          </div>

          <div className={`collapse ${!isCollapsed ? "show" : ""}`}>
            <div className="table-responsive mt-2">
              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th></th>
                    {section.columns.map((col, i) => (
                      <th key={`forward-col-${i}`}>{col.column_name}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {section.inputs.map((input, inputIndex) => (
                    <tr key={`forward-row-${input.row_id}`}>
                      <td>{input.row_title}</td>
                      {section.columns.map((column, colIndex) => (
                        <td key={`forward-cell-${colIndex}`}>
                          <input
                            type="text"
                            className="form-control"
                            value={input[column.column_name] || ""}
                            disabled={this.state.isDisabled}
                            onChange={(e) =>
                              this.handleTemplateChange(
                                sectionIndex,
                                `inputs.${inputIndex}.${column.column_name}`,
                                e.target.value
                              )
                            }
                          />
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderTasksSection(section, sectionIndex) {
    const isCollapsed = this.state.collapsedSections[sectionIndex] ?? true;

    return (
      <div className="pd-t-0 pd-b-0 pd-l-70 pd-r-70" key={sectionIndex}>
        <div key={`tasks-${sectionIndex}`} className="mb-4 border-bottom pb-3">
          <div
            className="d-flex justify-content-between align-items-center cursor-pointer"
            onClick={() => this.toggleSection(sectionIndex)}
            style={{ cursor: "pointer" }}
          >
            <h3 className="mb-0 text-uppercase">
              {section.table_tag}
              {section?.section_type !== "calendar" && (section.inputs?.some((input) =>
                section.columns?.some((column) => input[column.column_name])
              ) ||
                section.tasks?.some((task) => task.values?.some((v) => v))) && (
                <span className="change-daily-log-dot"></span>
              )}
              {section?.section_type === "calendar" && section.tasks.length > 0 && (
                <span className="change-daily-log-dot"></span>
              )}
            </h3>
            <div className="d-flex align-items-center">
              {/* <div className={`visible ${isCollapsed ? 'd-none' : 'd-flex'}`}>
                {this.renderSectionHeader(section, sectionIndex)}
              </div> */}
              <span className="Collapsible-arrow log-arrow c-gray-color">
                <i
                  className={`fa fa-angle-${isCollapsed ? "down" : "up"} fs-4`}
                ></i>
              </span>
            </div>
          </div>

          <div className={`collapse ${!isCollapsed ? "show" : ""}`}>
            <div className="form-group mt-2">
              {section.tasks.map((task, taskIndex) =>
                task.event_slug && task.event_slug !== undefined ? (
                  <div className="mb-3 d-flex" key={`task-${taskIndex}`}>
                    <label
                      className="check_cust audit-temp-checkbox d-inline-block"
                      htmlFor={`task-${sectionIndex}-${taskIndex}`}
                    >
                      <input
                        type="checkbox"
                        name="is_exclude"
                        className="form-check-input"
                        disabled={this.state.isDisabled}
                        onChange={(e) =>
                          this.handleTemplateChange(
                            sectionIndex,
                            `tasks.${taskIndex}.values.0`,
                            e.target.checked
                          )
                        }
                        checked={task.values[0] || false}
                        id={`task-${sectionIndex}-${taskIndex}`}
                      />

                      <span className="checkmark"></span>
                    </label>
                    <span
                      className="event-title-checkbox-link"
                      onClick={() => this.getEventDetail(task.event_slug)}
                    >
                      {task.label}
                    </span>
                  </div>
                ) : (
                  <div className="mb-3" key={`task-${taskIndex}`}>
                    <label
                      className="check_cust audit-temp-checkbox"
                      htmlFor={`task-${sectionIndex}-${taskIndex}`}
                    >
                      <input
                        type="checkbox"
                        name="is_exclude"
                        className="form-check-input"
                        disabled={this.state.isDisabled}
                        onChange={(e) =>
                          this.handleTemplateChange(
                            sectionIndex,
                            `tasks.${taskIndex}.values.0`,
                            e.target.checked
                          )
                        }
                        checked={task.values[0] || false}
                        id={`task-${sectionIndex}-${taskIndex}`}
                      />
                      {task.label}
                      <span className="checkmark"></span>
                    </label>
                  </div>
                )
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderLogEntriesSection(section, sectionIndex) {
    // Utility: count total replies in a category
    this.logEntriesRef = React.createRef();
    const totalEntriesInCategory = (cat) =>
      (section.logs[cat]?.entries || []).length;

    return (
      <div
        key={`log-entries-${sectionIndex}`}
        className="mt-5"
        id="logEntriesSection"
        ref={this.logEntriesRef}
      >
        <h3 className="mb-3 text-uppercase">{section.table_tag}</h3>
        <div
          className="accordion pd-t-0 pd-b-0 pd-l-70 pd-r-70"
          id={`logEntriesAccordion-${sectionIndex}`}
        >
          {section.categories.map((category, catIndex) => {
            const key = `${sectionIndex}-${catIndex}`;
            const entries = section.logs[category]?.entries || [];
            const hasValidEntries = entries.length > 0;
            const entryCount = totalEntriesInCategory(category);

            // Smart open state
            const isOpen = this.state.openCategories?.[key] || false;

            return (
              <div className="accordion-item" key={`log-category-${catIndex}`}>
                {/* Accordion Header */}
                <div
                  className="accordion-header d-flex justify-content-between align-items-center p-2"
                  onClick={() => this.toggleCategory(sectionIndex, catIndex)}
                  style={{ cursor: "pointer" }}
                >
                  <div className="d-flex align-items-center">
                    <h5 className="accordion-title mb-0 position-relative d-flex">
                      {category}
                      {entryCount > 0 && (
                        <span className="me-2 added-reply-count">
                          {entryCount}
                        </span>
                      )}
                    </h5>
                  </div>

                  <div
                    className="d-flex align-items-center"
                    onClick={(e) => e.stopPropagation()}
                  >
                    {this.state.is_thread_enable === 1 && (
                      <button
                        type="button"
                        className="gf-primary-btn-small-one log-button ms-2"
                        onClick={(e) => {
                          e.stopPropagation();
                          this.openLogEntryModal(category, e, 1);
                        }}
                      >
                        Add to Log
                      </button>
                    )}
                    {hasValidEntries ? (
                      <>
                        <span
                          className="Collapsible-arrow log-arrow"
                          onClick={() =>
                            this.toggleCategory(sectionIndex, catIndex)
                          }
                        >
                          {isOpen ? (
                            <i className="fa fa-angle-up"></i>
                          ) : (
                            <i className="fa fa-angle-down"></i>
                          )}
                        </span>
                      </>
                    ) : (
                      <span className="d-inline-block pd-l-20"></span>
                    )}
                  </div>
                </div>

                {/* Accordion Content */}
                <div className={`collapse ${isOpen ? "show" : ""}`}>
                  <div className="card-body">
                    {hasValidEntries ? (
                      entries.map((entry, entryIndex) => {
                        const canEditLogEntry =
                          (global.userPermissions.checkPermission(
                            "daily_logs-update-thread"
                          ) && userSessionData.user_id === entry.userId) 
                          || (global.userPermissions.checkPermission(
                            "daily_logs-update-thread-others"
                          ));

                        const canDeleteLogEntry =
                          (global.userPermissions.checkPermission(
                            "daily_logs-delete-thread"
                          ) && userSessionData.user_id === entry.userId) 
                          || global.userPermissions.checkPermission(
                            "daily_logs-delete-thread-others"
                          );

                          const showMoreInfoIconEntry =
                                    this.state.is_thread_enable === 1 &&
                                    (canEditLogEntry || canDeleteLogEntry);

                        const replies = entry.replies || [];

                        return (
                          <div
                            key={`entry-${entryIndex}`}
                            className="mb-3 bg-white"
                          >
                            <div className="d-flex justify-content-between author-edit-by">
                              <div className="d-flex align-items-center">
                                <div className="author-first-text">
                                  {entry.user?.charAt(0).toUpperCase()}
                                </div>
                                <small className="">
                                  <span>{entry.user} - </span>
                                  {Moment(entry.timestamp).format(
                                    "DD MMM, YY - hh:mm A"
                                  )}
                                </small>
                              </div>
                               {showMoreInfoIconEntry && (
                                  <div className="more-action-btn-dropdown">
                                    <img src={MoreInfoIcon} alt="" />
                                    <div className="reply-action-btn">
                                      {canEditLogEntry && (
                                        <button
                                          type="button"
                                          className="button addCat"
                                          onClick={(e) =>
                                            this.openLogEntryModal(
                                              category,
                                              entryIndex,
                                              entry,
                                              e,
                                              2
                                            )
                                          }
                                        >
                                          <img src={EditpenIcon} alt="Edit" />
                                        </button>
                                      )}
                                      {canDeleteLogEntry && (
                                        <button
                                          type="button"
                                          className="button deleteCat position-static pt-1"
                                          onClick={(e) =>
                                            this.openDeleteThreadModal(
                                              category,
                                              entryIndex,
                                              entry.slug,
                                              e
                                            )
                                          }
                                        >
                                          <img src={deleteicon} alt="Delete" />
                                        </button>
                                      )}
                                    </div>
                                  </div>
                                )}
                            </div>
                            <div className="mt-2 pl-3 d-flex mb-2">
                              <p className="mb-0 flex-grow-1 pr-3">
                                <div
                                  className="text-editor-para"
                                  dangerouslySetInnerHTML={{
                                    __html: this.modifyTaskName(entry.text),
                                  }}
                                />
                              </p>
                              {this.state.is_thread_enable === 1 &&
                                global.userPermissions.checkPermission(
                                  "daily_logs-reply-add"
                                ) && (
                                  <button
                                    type="button"
                                    className="gf-primary-btn-small-one ml-auto log-reply-btn"
                                    onClick={(e) =>
                                      this.openReplyModal(
                                        category,
                                        entryIndex,
                                        null,
                                        e,
                                        entry.slug,
                                        null,
                                        1
                                      )
                                    }
                                  >
                                    Add Reply
                                  </button>
                                )}
                            </div>
                            {/* Entry Images */}
                            <div className="cnt_center justify-content-start row">
                              {entry.images?.length > 0 && (
                                <div className="position-relative pl-4 pr-3">
                                  <div className="daily_log_info_imgbox mt-2">
                                    {entry.images.map((image) => (
                                      <div
                                        key={image.slug}
                                        className="img_close"
                                        onClick={() =>
                                          this.imageRedirect(
                                            image.uri_web || image.src
                                          )
                                        }
                                      >
                                        <div className="pop-up-image-megnify">
                                          <ReactImageMagnify
                                            {...{
                                              smallImage: {
                                                alt: image.slug,
                                                isFluidWidth: true,
                                                src:
                                                  image.uri_web ||
                                                  image.src ||
                                                  placeholderImage,
                                                onError: ({
                                                  currentTarget,
                                                }) => {
                                                  currentTarget.onerror = null;
                                                  currentTarget.src =
                                                    placeholderImage;
                                                },
                                              },
                                              largeImage: {
                                                src:
                                                  image.uri_web ||
                                                  image.src ||
                                                  placeholderImage,
                                                width: 200,
                                                height: 200,
                                              },
                                              enlargedImagePosition: "beside",
                                              enlargedImageContainerDimensions:
                                                {
                                                  width: "300%",
                                                  height: "300%",
                                                },
                                              className: "custom-image-magnify",
                                            }}
                                          />
                                        </div>
                                        {!this.state.isDisabled && (
                                          <button
                                            type="button"
                                            className="btN btn_remove position-absolute"
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              this.toggleModal(
                                                image.slug,
                                                false
                                              );
                                            }}
                                          >
                                            <span className="fa fa-times"></span>
                                          </button>
                                        )}
                                      </div>
                                    ))}
                                  </div>
                                </div>
                              )}
                            </div>
                            {/* Replies Section */}
                            {replies.length > 0 && (
                              <div className="py-2 mt-2 pl-3">
                                {/* <small className="position-relative">Replies
                                  <span className="me-2 added-reply-count">
                                    {replies.length}
                                  </span>
                                </small> */}
                                {replies.map((reply, replyIndex) => {
                                  const canEditReply =
                                    (global.userPermissions.checkPermission(
                                      "daily_logs-reply-edit"
                                    ) && userSessionData.user_id === reply.userId) ||
                                    global.userPermissions.checkPermission(
                                      "daily_logs-reply-edit-others"
                                    );

                                  const canDeleteReply =
                                    (global.userPermissions.checkPermission(
                                      "daily_logs-reply-delete"
                                    ) && userSessionData.user_id === reply.userId) ||
                                    global.userPermissions.checkPermission(
                                      "daily_logs-reply-delete-others"
                                    );

                                  const showMoreInfoIcon =
                                    this.state.is_thread_enable === 1 &&
                                    (canEditReply || canDeleteReply);
                                  return (
                                    <div
                                      key={replyIndex}
                                      className="reply-content-box"
                                    >
                                      <div
                                        key={`reply-${reply.slug}`}
                                        className="mb-2 position-relative row"
                                      >
                                        <div className="col-md-9">
                                          <p className="mb-0">
                                            <div
                                              className="text-editor-para"
                                              dangerouslySetInnerHTML={{
                                                __html: this.modifyTaskName(
                                                  reply.text
                                                ),
                                              }}
                                            />
                                          </p>
                                          {reply.images &&
                                            reply.images.length > 0 && (
                                              <div className="cnt_center justify-content-start row mt-2">
                                                <div className="position-relative">
                                                  <div className="daily_log_info_imgbox">
                                                    {reply.images.map(
                                                      (image) => (
                                                        <div
                                                          key={image.slug}
                                                          className="img_close"
                                                          onClick={() =>
                                                            this.imageRedirect(
                                                              image.uri_web || image.src
                                                            )
                                                          }
                                                        >
                                                          <div className="pop-up-image-megnify">
                                                            <ReactImageMagnify
                                                              {...{
                                                                smallImage: {
                                                                  alt: image.slug,
                                                                  isFluidWidth: true,
                                                                  src:
                                                                    image.uri_web ||
                                                                    image.src ||
                                                                    placeholderImage,
                                                                  onError: ({
                                                                    currentTarget,
                                                                  }) => {
                                                                    currentTarget.onerror =
                                                                      null;
                                                                    currentTarget.src =
                                                                      placeholderImage;
                                                                  },
                                                                },
                                                                largeImage: {
                                                                  src:
                                                                    image.uri_web ||
                                                                    image.src ||
                                                                    placeholderImage,
                                                                  width: 200,
                                                                  height: 200,
                                                                },
                                                                enlargedImagePosition:
                                                                  "beside",
                                                                enlargedImageContainerDimensions:
                                                                  {
                                                                    width:
                                                                      "300%",
                                                                    height:
                                                                      "300%",
                                                                  },
                                                                className:
                                                                  "custom-image-magnify",
                                                              }}
                                                            />
                                                          </div>
                                                          {!this.state
                                                            .isDisabled && (
                                                            <button
                                                              type="button"
                                                              className="btN btn_remove position-absolute"
                                                              onClick={(e) => {
                                                                e.stopPropagation();
                                                                this.toggleModal(
                                                                  image.slug,
                                                                  true,
                                                                  category,
                                                                  entryIndex,
                                                                  replyIndex
                                                                );
                                                              }}
                                                            >
                                                              <span className="fa fa-times"></span>
                                                            </button>
                                                          )}
                                                        </div>
                                                      )
                                                    )}
                                                  </div>
                                                </div>
                                              </div>
                                            )}
                                        </div>
                                        <div
                                          className={`col-md-3 ${
                                            this.state.is_thread_enable != 1
                                              ? "d-flex  flex-row-reverse"
                                              : ""
                                          }`}
                                        >
                                          <div className="reply-autor-btnbox">
                                            <div className="author-edit-by">
                                              <small className="">
                                                <span>{reply.user} - </span>
                                                {Moment(reply.timestamp).format(
                                                  "DD MMM, YY - hh:mm A"
                                                )}
                                              </small>
                                            </div>

                                            {showMoreInfoIcon && (
                                              <div className="more-action-btn-dropdown">
                                                <img
                                                  src={MoreInfoIcon}
                                                  alt=""
                                                />
                                                <div className="reply-action-btn">
                                                  {canEditReply && (
                                                    <button
                                                      type="button"
                                                      className="button addCat"
                                                      onClick={(e) =>
                                                        this.openReplyModal(
                                                          category,
                                                          entryIndex,
                                                          replyIndex,
                                                          e,
                                                          entry.slug,
                                                          reply.slug,
                                                          2
                                                        )
                                                      }
                                                    >
                                                      <img
                                                        src={EditpenIcon}
                                                        alt="Edit"
                                                      />
                                                    </button>
                                                  )}

                                                  {canDeleteReply && (
                                                    <button
                                                      type="button"
                                                      className="button deleteCat position-static"
                                                      onClick={(e) =>
                                                        this.openDeleteReplyModal(
                                                          category,
                                                          entryIndex,
                                                          null,
                                                          reply.slug || null,
                                                          e
                                                        )
                                                      }
                                                    >
                                                      <img
                                                        src={deleteicon}
                                                        alt="Delete"
                                                      />
                                                    </button>
                                                  )}
                                                </div>
                                              </div>
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  );
                                })}
                              </div>
                            )}
                          </div>
                        );
                      })
                    ) : (
                      <div className="data-empty">No entries yet</div>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  }

  imageRedirect(path) {
    window.open(`${path}`);
  }

  openDeleteReplyModal = (category, entryIndex, replyIndex, replySlug, e) => {
    if (e) e.preventDefault();
    this.setState({
      showDeleteReplyModal: true,
      replyToDelete: replySlug,
      replyCategory: category,
      replyEntryIndex: entryIndex,
      replyIndex: replyIndex,
      loading: false,
    });
  };

  closeDeleteThreadModal = () => {
    this.setState({
      showDeleteThreadModal: false,
      threadToDelete: null,
      threadCategory: null,
      threadEntryIndex: null,
      loading: false,
    });
  };

  deleteThreadConfirmed = async () => {
    const { threadToDelete, threadCategory } = this.state;

    try {
      this.setState({ loading: true });

      if (threadToDelete) {
        const res = await DailyLogService.deleteDailyLogThreadNew(
          threadToDelete
        );
        if (!global.successStatus.includes(res.status)) {
          throw new Error(res.message || "Failed to delete thread");
        }
      }

      this.setState((prevState) => {
        const newSections = [...prevState.templateSections];
        const logSection = newSections.find(
          (s) => s.section_type === "log_entries"
        );

        if (logSection?.logs?.[threadCategory]?.entries) {
          // Remove the thread entry
          logSection.logs[threadCategory].entries = logSection.logs[
            threadCategory
          ].entries.filter((entry) => entry.slug !== threadToDelete);
        }

        if (this.state.slug == "add") {
          this.saveSection();
        } else {
          this.saveDailyLogs();
        }

        return {
          templateSections: newSections,
          showDeleteThreadModal: false,
          loading: false,
        };
      });
    } catch (error) {
      this.setState({
        showAlertModal: true,
        alertModalType: "error",
        alertModalTitle: "Error",
        alertModalMessage: error.message,
        loading: false,
      });
    }
  };

  openDeleteThreadModal = (category, entryIndex, threadSlug, e) => {
    if (e) e.preventDefault();
    this.setState({
      showDeleteThreadModal: true,
      threadToDelete: threadSlug,
      threadCategory: category,
      threadEntryIndex: entryIndex,
      loading: false,
    });
  };

  closeDeleteReplyModal = () => {
    this.setState({
      showDeleteReplyModal: false,
      replyToDelete: null,
      replyCategory: null,
      replyEntryIndex: null,
      replyIndex: null,
      loading: false,
    });
  };

  deleteReplyConfirmed = async () => {
    const { replyToDelete, replyCategory } = this.state;

    try {
      this.setState({ loading: true });
      if (replyToDelete) {
        const res = await DailyLogService.deleteDailyLogThreadReply(
          replyToDelete
        );
        if (!global.successStatus.includes(res.status)) {
          throw new Error(res.message || "Failed to delete reply");
        }
      }

      this.setState((prevState) => {
        const newSections = [...prevState.templateSections];
        const logSection = newSections.find(
          (s) => s.section_type === "log_entries"
        );

        if (logSection?.logs?.[replyCategory]?.entries) {
          // Scan every entry in the category and drop the matching slug
          logSection.logs[replyCategory].entries.forEach((entry) => {
            if (entry.replies && entry.replies.length) {
              entry.replies = entry.replies.filter(
                (r) => r.slug !== replyToDelete
              );
            }
          });
        }

        return {
          templateSections: newSections,
          showDeleteReplyModal: false,
          loading: false,
        };
      });
    } catch (error) {
      this.setState({
        showAlertModal: true,
        alertModalType: "error",
        alertModalTitle: "Error",
        alertModalMessage: error.message,
        loading: false,
      });
    }
  };

  saveLogEntry = async () => {
    const {
      currentLogCategory,
      newLogEntry,
      logEntryImages,
      isEditingEntry,
      editingEntry,
      currentEntryIndex,
    } = this.state;

    // Validate the entry has content
    if (
      !newLogEntry ||
      newLogEntry.replace(/<[^>]*>/g, "").trim().length === 0
    ) {
      this.setState({
        showAlertModal: true,
        alertModalType: "error",
        alertModalTitle: "Validation Error",
        alertModalMessage: "Please enter log entry content",
      });
      return;
    }

    // Set loading state
    this.setState({
      loading: true,
      isUploading: true,
      uploadProgress: 0,
      uploadedImagesCount: 0,
      totalImagesToUpload: logEntryImages.length,
      uploadStatus: "Preparing to upload...",
    });

    try {
      // User + meta
      const userData =
        JSON.parse(localStorage.getItem("userData")) || this.props.userData;
      const userName = userData ? userData.full_name : "Unknown User";

      // First save/update the log entry to get a slug
      const slug = await this.saveDailyLogThread();

      if (!slug) {
        throw new Error("Failed to save log entry");
      }

      // Upload images one by one
      const uploadedImages = [];
      for (let i = 0; i < logEntryImages.length; i++) {
        const image = logEntryImages[i];

        // Skip if image is already uploaded (has a slug)
        if (image.slug) {
          uploadedImages.push(image);
          continue;
        }

        this.setState({
          uploadStatus: `Uploading image ${i + 1} of ${
            logEntryImages.length
          }...`,
          currentImageIndex: i,
        });

        try {
          const uploadedImage = await this.onImageUpload(
            image,
            slug.slug,
            i,
            "thread"
          );
          uploadedImages.push(uploadedImage);

          this.setState((prevState) => ({
            uploadedImagesCount: prevState.uploadedImagesCount + 1,
            uploadProgress: Math.round(((i + 1) / logEntryImages.length) * 100),
          }));
        } catch (error) {
          console.error(`Failed to upload image ${i + 1}:`, error);
          continue;
        }
      }

      // Update state with the new/updated entry
      this.setState((prevState) => {
        const newSections = [...prevState.templateSections];
        const logSection = newSections.find(
          (s) => s.section_type === "log_entries"
        );
        const sectionIndex = newSections.findIndex(
          (s) => s.section_type === "log_entries"
        );
        const catIndex = logSection.categories.findIndex(
          (cat) => cat === currentLogCategory
        );
        const categoryKey = `${sectionIndex}-${catIndex}`;

        if (logSection) {
          // Ensure category bucket exists
          if (!logSection.logs) logSection.logs = {};
          if (!logSection.logs[currentLogCategory]) {
            logSection.logs[currentLogCategory] = { entries: [] };
          }

          const entries = logSection.logs[currentLogCategory].entries || [];

          if (
            isEditingEntry &&
            currentEntryIndex !== null &&
            entries[currentEntryIndex]
          ) {
            // Get current images and filter out deleted ones
            const currentImages = entries[currentEntryIndex].images || [];
            const filteredImages = currentImages.filter(
              (img) => !(this.state.deletedImages || []).includes(img.slug)
            );

            // Get slugs of existing images to check for duplicates
            const existingImageSlugs = new Set(
              filteredImages.map((img) => img.slug)
            );

            // Update existing entry
            const updatedEntry = {
              ...entries[currentEntryIndex],
              text: newLogEntry,
              images: [
                ...filteredImages,
                // Only add new images that don't already exist in the entry
                ...uploadedImages
                  .filter((img) => !existingImageSlugs.has(img.slug))
                  .map((img) => ({
                    ...img,
                    uri_web: img.uri_web || img.filePath || img.src,
                    uri_mobile: img.uri_mobile || img.filePath || img.src,
                    file_name:
                      img.file_name || img.file?.name || `image-${Date.now()}`,
                    file_type: img.file_type || img.file?.type || "image/jpeg",
                    file_size: img.file_size || img.file?.size || 0,
                    created_at: img.created_at || new Date().toISOString(),
                    updated_at: img.updated_at || new Date().toISOString(),
                  })),
              ],
              replies: entries[currentEntryIndex].replies || [],
            };

            entries[currentEntryIndex] = updatedEntry;
          } else {
            // Create new entry
            const newEntry = {
              deleted_images: [],
              slug: slug.slug || null,
              text: newLogEntry,
              user: userName,
              userId: userData?.user_id || null,
              timestamp: slug.created_at || "",
              images: uploadedImages.filter((img) => img), // Filter out any failed uploads
              processed: false,
              replies: editingEntry?.replies || [], // Preserve replies if editing
            };

            // Prepend the new entry
            entries.unshift(newEntry);
          }

          logSection.logs[currentLogCategory].entries = entries;
        }

        const updatedJson = {
          template_name: "Daily Operation Log",
          template_type: "template",
          sections: newSections,
        };
        /*if (this.state.slug == "add") {
          this.saveSection();
        } else {
          this.saveDailyLogs();
        }*/
        return {
          templateSections: newSections,
          templateData: updatedJson,
          showLogEntryModal: false,
          newLogEntry: "",
          logEntryImages: [],
          loading: false,
          isUploading: false,
          uploadProgress: 100,
          uploadStatus: "Upload complete!",
          openCategories: {
            ...prevState.openCategories,
            [categoryKey]: true,
          },
          editingEntryId: null, // Reset editing state
          isEditingEntry: false, // Reset editing flag
        };
      });
    } catch (error) {
      console.error("Error saving log entry:", error);
      this.setState({
        loading: false,
        isUploading: false,
        showAlertModal: true,
        alertModalType: "error",
        alertModalTitle: "Error",
        alertModalMessage: error.message || "Failed to save log entry",
      });
    }
  };

  saveReply = async () => {
    const {
      currentReplyCategory,
      currentEntryIndex,
      currentReplyIndex,
      newReply,
      replyImages,
    } = this.state;

    // Validate the reply has content
    if (!newReply || newReply.replace(/<[^>]*>/g, "").trim().length === 0) {
      this.setState({
        showAlertModal: true,
        alertModalType: "error",
        alertModalTitle: "Validation Error",
        alertModalMessage: "Please enter reply content",
      });
      return;
    }

    // Set loading state
    this.setState({
      loading: true,
      isUploadingReply: true,
      replyUploadProgress: 0,
      replyUploadStatus: "Preparing to upload...",
    });

    try {
      // User + meta
      const userData =
        JSON.parse(localStorage.getItem("userData")) || this.props.userData;
      const userName = userData ? userData.full_name : "Unknown User";

      // First save the reply to get a slug (this now handles image deletion too)
      const slug = await this.saveDailyLogReply();

      if (!slug) {
        throw new Error("Failed to save reply");
      }

      // Upload images one by one
      const uploadedImages = [];
      for (let i = 0; i < replyImages.length; i++) {
        const image = replyImages[i];

        // Skip if image is already uploaded (has a slug)
        if (image.slug) {
          uploadedImages.push(image);
          continue;
        }

        this.setState({
          replyUploadStatus: `Uploading image ${i + 1} of ${
            replyImages.length
          }...`,
        });

        try {
          const uploadedImage = await this.onImageUpload(
            image,
            slug.slug,
            i,
            "reply"
          );
          uploadedImages.push(uploadedImage);

          this.setState((prevState) => ({
            replyUploadProgress: Math.round(
              ((i + 1) / replyImages.length) * 100
            ),
          }));
        } catch (error) {
          console.error(`Failed to upload image ${i + 1}:`, error);
          continue;
        }
      }

      // Update state with the new/updated reply
      this.setState((prevState) => {
        const newSections = [...prevState.templateSections];
        const logSection = newSections.find(
          (s) => s.section_type === "log_entries"
        );

        if (logSection) {
          if (!logSection.logs) logSection.logs = {};
          if (!logSection.logs[currentReplyCategory]) {
            logSection.logs[currentReplyCategory] = { entries: [] };
          }

          const entry =
            logSection.logs[currentReplyCategory].entries[currentEntryIndex];

          if (entry) {
            if (!entry.replies) entry.replies = [];

            const replyData = {
              slug: slug.slug || null,
              text: newReply,
              user: userName,
              userId: userData?.user_id || null,
              timestamp: slug.created_at || "",
              processed: false,
              threadSlug: entry.slug,
            };

            if (currentReplyIndex !== null) {
              // EDIT - keep existing position
              // Get current images (already filtered by deleted images in saveDailyLogReply)
              const currentImages =
                entry.replies[currentReplyIndex].images || [];

              // Get slugs of existing images to check for duplicates
              const existingImageSlugs = new Set(
                currentImages.map((img) => img.slug)
              );

              // Update with new images (avoid duplicates)
              replyData.images = [
                ...currentImages,
                ...uploadedImages
                  .filter((img) => !existingImageSlugs.has(img.slug))
                  .map((img) => ({
                    ...img,
                    uri_web: img.uri_web || img.filePath || img.src,
                    uri_mobile: img.uri_mobile || img.filePath || img.src,
                    file_name:
                      img.file_name || img.file?.name || `image-${Date.now()}`,
                    file_type: img.file_type || img.file?.type || "image/jpeg",
                    file_size: img.file_size || img.file?.size || 0,
                    created_at: img.created_at || new Date().toISOString(),
                    updated_at: img.updated_at || new Date().toISOString(),
                  })),
              ];

              entry.replies[currentReplyIndex] = replyData;
            } else {
              // NEW - prepend to beginning
              replyData.images = uploadedImages.map((img) => ({
                ...img,
                uri_web: img.uri_web || img.filePath || img.src,
                uri_mobile: img.uri_mobile || img.filePath || img.src,
                file_name:
                  img.file_name || img.file?.name || `image-${Date.now()}`,
                file_type: img.file_type || img.file?.type || "image/jpeg",
                file_size: img.file_size || img.file?.size || 0,
                created_at: img.created_at || new Date().toISOString(),
                updated_at: img.updated_at || new Date().toISOString(),
              }));

              entry.replies = [replyData, ...entry.replies];
            }
          }
        }

        const updatedJson = {
          template_name: "Daily Operation Log",
          template_type: "template",
          sections: newSections,
        };

        return {
          templateSections: newSections,
          templateData: updatedJson,
          showReplyModal: false,
          newReply: "",
          replyImages: [],
          replyDeletedImages: [],
          currentReplyIndex: null,
          loading: false,
          isUploadingReply: false,
          replyUploadProgress: 100,
          replyUploadStatus: "Upload complete!",
        };
      });
    } catch (error) {
      console.error("Error saving reply:", error);
      this.setState({
        loading: false,
        isUploadingReply: false,
        showAlertModal: true,
        alertModalType: "error",
        alertModalTitle: "Error",
        alertModalMessage: error.message || "Failed to save reply",
      });
    }
  };

  handleReplyImageUpload = async (event) => {
    const files = event.target.files;

    // Validate total images
    if (this.state.replyImages.length + files.length > 10) {
      this.setState({
        error: "You can only upload a maximum of 10 images.",
      });
      event.target.value = ""; // Reset the file input
      return;
    }

    this.setState({ isLoading: true });
    const newImages = [];

    try {
      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        const fileSize = file.size;
        const options = {
          maxSizeMB: 1,
          maxWidthOrHeight: 1920,
          useWebWorker: true,
        };

        let processedFile = file;

        // Compress the image if it's larger than 2MB
        if (fileSize >= 2e6) {
          try {
            processedFile = await imageCompression(file, options);
          } catch (error) {
            console.error("Error compressing image:", error);
            processedFile = file;
          }
        }

        newImages.push({
          file: processedFile,
          src: URL.createObjectURL(processedFile),
          id: Date.now() + i,
          isUploaded: false,
          originalFile: file,
          isCompressed: fileSize >= 2e6,
        });
      }

      this.setState((prevState) => ({
        replyImages: [...prevState.replyImages, ...newImages],
        error: "",
        isLoading: false,
      }));
    } catch (error) {
      console.error("Error processing images:", error);
      this.setState({
        error: "Error processing images. Please try again.",
        isLoading: false,
      });
    }
  };

  deleteReplyImage = async (index) => {
    this.setState((prevState) => {
      const image = prevState.replyImages[index];
      const newImages = [...prevState.replyImages];
      const newDeletedImages = [...prevState.replyDeletedImages];

      // If image has a slug (already uploaded), add to deletedImages
      if (image && image.slug) {
        newDeletedImages.push(image.slug);
      }

      // Remove image from display
      newImages.splice(index, 1);

      return {
        replyImages: newImages,
        replyDeletedImages: newDeletedImages,
      };
    });
  };

  toggleCategory = (sectionIndex, catIndex) => {
    this.setState((prevState) => {
      const key = `${sectionIndex}-${catIndex}`;
      return {
        openCategories: {
          ...prevState.openCategories,
          [key]: !prevState.openCategories[key],
        },
      };
    });
  };

  handleTemplateChange = (sectionIndex, fieldPath, value) => {
    this.setState((prevState) => {
      const newSections = JSON.parse(
        JSON.stringify(prevState.templateSections)
      );
      const pathParts = fieldPath.split(".");

      // Start at the section
      let current = newSections[sectionIndex];

      // Traverse the path except the last part
      for (let i = 0; i < pathParts.length - 1; i++) {
        const part = pathParts[i];
        if (!isNaN(part)) {
          current = current[parseInt(part)];
        } else {
          current = current[part];
        }
      }

      // Set the value at the final path part
      const lastPart = pathParts[pathParts.length - 1];
      if (!isNaN(lastPart)) {
        current[parseInt(lastPart)] = value;
      } else {
        current[lastPart] = value;
      }
      // this.setState({ hasUnsavedChanges: true });
      // Build the final JSON structure
      const updatedJson = {
        template_name: "Daily Operation Log",
        template_type: "template",
        sections: newSections,
      };
      return {
        templateSections: newSections,
        templateData: updatedJson,
        hasUnsavedChanges: prevState.is_thread_enable !== 2,
      };
    });
  };

  handleChangeReply(value) {
    const isEmptyValue =
      !value ||
      value === "<p><br></p>" ||
      value === "<p></p>" ||
      value.trim() === "<p><br></p>" ||
      value.trim() === "<p></p>";
    const newReplyValue = isEmptyValue ? "" : value;
    this.setState(
      {
        newReply: newReplyValue,
      },
      () => {
        this.customValidate();
      }
    );
  }

  handleChangeModal(value) {
    const isEmptyValue =
      !value ||
      value === "<p><br></p>" ||
      value === "<p></p>" ||
      value.trim() === "<p><br></p>" ||
      value.trim() === "<p></p>";
    const newLogEntryValue = isEmptyValue ? "" : value;
    this.setState(
      {
        newLogEntry: newLogEntryValue,
      },
      () => {
        this.customValidate();
      }
    );
  }
  changeHandler = (event) => {
    let input = this.state.input;
    let value = event.target.value;
    input[event.target.name] = value;
    this.setState({
      [event.target.name]: value,
      input: input,
      hasUnsavedChanges: true,
    });
    this.validator.showMessageFor(event.target.name);
    this.customValidate();
  };
  // Property Change Handler
  handleChangeProperty(value) {
    let property_slug = [];
    if (value != null && value.length > 0) {
      value.forEach((item, i) => {
        property_slug.push(item.value);
      });
    }

    this.setState({
      selectedPropertyList: value,
      property_slug: value.value,
    });
    this.setState({ confirm_back: 1 });
  }
  closeModal() {
    this.validator.hideMessages();
    this.validator = new SimpleReactValidator({ autoForceUpdate: this });
    this.setState({ showAlertModal: false });
    this.setState({ addModal: false });
    this.setState({
      building_name: "",
      sort_order: "",
      errors: {},
    });
  }
  customValidate() {
    let isValid = true;
    return isValid;
  }

  toggleModal = (
    slug,
    isReply = false,
    category = null,
    entryIndex = null,
    replyIndex = null
  ) => {
    this.setState({
      showModalImage: !this.state.showModalImage,
      imageSlug: slug,
      isReplyImage: isReply,
      imageCategory: category,
      imageEntryIndex: entryIndex,
      imageReplyIndex: replyIndex,
    });
  };

  handleImageDelete = async () => {
    const {
      imageSlug,
      isReplyImage,
      imageCategory,
      imageEntryIndex,
      imageReplyIndex,
    } = this.state;

    this.setState({ loading: true, isSubmit: true });

    try {
      let res = await ActionItemService.deleteImage(imageSlug);

      if (global.successStatus.includes(res.status)) {
        if (isReplyImage) {
          // Handle reply image deletion
          this.setState((prevState) => {
            const newSections = [...prevState.templateSections];
            const logSection = newSections.find(
              (s) => s.section_type === "log_entries"
            );

            if (
              logSection &&
              logSection.logs &&
              imageCategory &&
              imageEntryIndex !== null &&
              imageReplyIndex !== null
            ) {
              // Find the specific reply and remove the image
              const reply =
                logSection.logs[imageCategory]?.entries[imageEntryIndex]
                  ?.replies[imageReplyIndex];
              if (reply && reply.images) {
                reply.images = reply.images.filter(
                  (img) => img.slug !== imageSlug
                );
              }
            }

            return {
              templateSections: newSections,
              showAlertModal: true,
              alertModalType: "success",
              alertModalTitle: "Success",
              alertModalMessage: "Reply image deleted successfully",
              showModalImage: false,
              loading: false,
              isSubmit: false,
            };
          });
        } else {
          // Handle thread image deletion (existing logic)
          this.setState((prevState) => {
            // 1. Remove from dailyLogImages
            const updatedDailyLogImages = prevState.dailyLogImages.filter(
              (img) => img.slug !== imageSlug
            );

            // 2. Remove from templateSections (log entries)
            const updatedTemplateSections = prevState.templateSections.map(
              (section) => {
                if (section.section_type === "log_entries") {
                  const updatedLogs = {};

                  // Iterate through all categories
                  Object.keys(section.logs || {}).forEach((category) => {
                    // Filter out the image from all entries in this category
                    updatedLogs[category] = {
                      entries: section.logs[category].entries.map((entry) => ({
                        ...entry,
                        images:
                          entry.images?.filter(
                            (img) => img.slug !== imageSlug
                          ) || [],
                      })),
                    };
                  });

                  return {
                    ...section,
                    logs: updatedLogs,
                  };
                }
                return section;
              }
            );

            // 3. Update the templateData to match
            const updatedTemplateData = {
              ...prevState.templateData,
              sections: updatedTemplateSections,
            };

            return {
              dailyLogImages: updatedDailyLogImages,
              templateSections: updatedTemplateSections,
              templateData: updatedTemplateData,
              showAlertModal: true,
              alertModalType: "success",
              alertModalTitle: "Success",
              alertModalMessage: "Image deleted successfully",
              showModalImage: false,
              loading: false,
              isSubmit: false,
            };
          });
        }
      } else {
        throw new Error(res.message || "Failed to delete image");
      }
    } catch (error) {
      this.setState({
        loading: false,
        isSubmit: false,
        showAlertModal: true,
        alertModalType: "error",
        alertModalTitle: "Error!",
        alertModalMessage: error.message,
      });
    }

    setTimeout(
      () => this.setState({ showAlertModal: false }),
      global.alert_close_time
    );
  };

  opendeleteDailyLogModal(slug) {
    this.setState({ deleteDailyLogModal: true });
  }

  opendeleteDailyLogThreadModal(slug) {
    this.setState({ deleteDailyLogThreadModal: true, threadSlug: slug });
  }

  closedeleteDailyLogModal() {
    this.setState({ deleteDailyLogModal: false });
  }
  closedeleteDailyLogThreadModal() {
    this.setState({ deleteDailyLogThreadModal: false });
  }

  // Delete Method Start
  async deleteDailyLog(slug) {
    this.setState({ loading: true, isDelete: true });
    let res = await DailyLogService.deleteDailyLog(slug);
    if (global.successStatus.includes(res.status)) {
      this.closedeleteDailyLogModal();
      this.setState({
        showAlertModal: true,
        alertModalType: "success",
        alertModalTitle: "Success",
        alertModalMessage: res.message ? res.message : "Success",
      });
      setTimeout(
        () => this.props.history.push("/daily-logs/"),
        global.redirect_time
      );
    } else {
      this.closedeleteDailyLogModal();
      this.setState({
        showAlertModal: true,
        alertModalType: "error",
        alertModalTitle: res.data.errorCode ? res.data.errorCode : "Error!",
        alertModalMessage: res.data.errorMessage
          ? res.data.errorMessage
          : res.data.message,
      });
    }
    this.setState({ loading: false, isDelete: false });
    setTimeout(
      () => this.setState({ showAlertModal: false }),
      global.alert_close_time
    );
  }

  // Delete thread Method Start
  async deleteDailyLogThread(slug) {
    this.setState({ loading: true, isDelete: true });
    let res = await DailyLogService.deleteDailyLogThread(slug);
    if (global.successStatus.includes(res.status)) {
      this.closedeleteDailyLogThreadModal();
      this.setState({
        showAlertModal: true,
        alertModalType: "success",
        alertModalTitle: "Success",
        alertModalMessage: res.message ? res.message : "Success",
      });
      setTimeout(
        () => this.props.history.push("/daily-log/" + this.state.slug),
        global.redirect_time
      );
      this.getData();
    } else {
      this.closedeleteDailyLogThreadModal();
      this.setState({
        showAlertModal: true,
        alertModalType: "error",
        alertModalTitle: res.data.errorCode ? res.data.errorCode : "Error!",
        alertModalMessage: res.data.errorMessage
          ? res.data.errorMessage
          : res.data.message,
      });
    }
    this.setState({ loading: false, isDelete: false });
    setTimeout(
      () => this.setState({ showAlertModal: false }),
      global.alert_close_time
    );
  }

  modifyTaskName(taskName) {
    // Create a temporary element to manipulate the HTML string
    const tempElement = document.createElement("div");
    tempElement.innerHTML = taskName;

    // Find all links in the element
    const links = tempElement.querySelectorAll("a");
    links.forEach((link) => {
      link.setAttribute("target", "_blank");
    });

    // Return the modified HTML
    return tempElement.innerHTML;
  }

   async exportPdf() {
    
    const queryString = `property_slug=${this.state.property_slug}&daily_log_slug=${this.state.daily_log_slug}`;
    this.setState({ loading: true });
    var list = [];
    let res = await DailyLogService.exportSingleLogs(queryString);
    if (global.successStatus.includes(res.status)) {
      list = res.data.report["0"] ? res.data.report["0"] : [];
    }
    this.setState({ list: list });
    this.setState({ loading: false });
    window.open(this.state.list.filePath, "_blank");
   
    }

  render() {
    const { error } = this.state;
    const modules = {
      toolbar: {
        container: "#toolbar",
        handlers: {
          link: this.handleLink,
        },
      },
    };
    const modulesmodal = {
      toolbar: {
        container: "#toolbar-modal",
        handlers: {
          link: this.handleModalEditorLink,
        },
      },
    };

    const showConfirmModal =
      this.state.showConfirmModal && this.state.is_thread_enable !== 2;
      const showAddNewdailylogConfirmModal = this.state.showAddNewdailylogConfirmModal;
      const showPastDatedailylogInfoModal = this.state.showPastDatedailylogInfoModal;
    return (
      <div>
        <main>
          {this.state.showSpinner && (
            <div className="spinnerLoader1">
              <div className="toploader1">
                <img
                  src={require("../../assets/images/Loader-new.gif").default}
                  alt="Loading"
                />
              </div>
            </div>
          )}
          <div className="container-fluid">
            <div className="row m-0">
              <div className="col-md-12 p-0">
                <div className="dashbaord-pageHeadertitle heading_alignment">
                  <h3 className="flex-column">
                    <div className="d-flex justify-content-between align-items-center w-100">
                      <h3>Daily Log</h3>
                       {this.state.slug != "add" ? (
                        <div className="d-flex justify-content-between align-items-center">
                          <span className="Collapsible-arrow log-arrow c-gray-color dateleftarrow btn_arrow_header"
                            onClick={() => this.handleArrowClick(-1)}  >
                            <i
                              className={`fa fa-angle-left fs-4`}
                            ></i>
                          </span>
                          <div className="justify-content-center">
                              <Col
                                  md={12}
                                  lg={12}
                                  xl={12}
                                  className="mb-md-0 mb-3 pb-0 px-2"
                                >
                                  <DatePicker
                                    className="form-control max_width_100"
                                    wrapperClassName="input_date_wrap"
                                    showMonthDropdown
                                    showYearDropdown
                                    scrollableYearDropdown
                                    autoComplete="off"
                                    yearDropdownItemNumber={
                                      global.yearDropdownItemNumber
                                    }
                                    name="filter_for_daily_log"
                                    placeholderText="dd-mm-yy"
                                    dateFormat="dd MMM yy"
                                    selected={
                                      
                                      this.state.convert_created_at
                                      ? new Date(this.state.convert_created_at) // Use the stored date (already local)
                                      : this.state.filter_for_daily_log
                                      ? new Date(this.state.filter_for_daily_log)
                                      : this.state.selectedDate
                                      ? new Date(this.state.selectedDate)
                                      : null
                                    }
                                    onChange={(data) =>
                                      this.getDatabyfilter({
                                        target: {
                                          type: "date",
                                          name: "filter_for_daily_log",
                                          value: data,
                                        },
                                      })
                                    }
                                    maxDate={this.state.filter_created_on}
                                  />
                              </Col>
                          </div>
                          <span className="Collapsible-arrow log-arrow c-gray-color daterightarrow btn_arrow_header"
                            onClick={() => this.handleArrowClick(1)}>
                            <i
                              className={`fa fa-angle-right fs-4`}
                            ></i>
                          </span>                          
                        </div>) : ''}

                      <div className="btnNavigate d-flex justify-content-end">
                        <a href="#" onClick={this.handleBackClick}>
                          <img src={back} alt="" />
                          Back
                        </a>
                        {/* </div> */}
                      </div>
                    </div>
                    <span>Daily Log Detail</span>
                  </h3>
                </div>
              </div>

              <div className="col-md-12 pl-0 pr-0">
                <Alerts
                  show={this.state.showAlertModal}
                  type={this.state.alertModalType}
                  title={this.state.alertModalTitle}
                  message={this.state.alertModalMessage}
                  onClose={() => this.setState({ showAlertModal: false })}
                />
              </div>
              {/* for inspection info */}
             
              <div
                className={`col-md-${
                  this.state.showVersionHistory ? "9" : "12"
                } mg-t-0 dashboardRightcard`}
              >
                <div className="tabNavigation ">
                  <div className="row row-xs align-items-center justify-content-end flex-wrap m-0 pd-b-0">
                    <div className="col-md-12 btnNavigate d-flex justify-content-end align-items-center flex-wrap-bothBtn p-0">
                      {this.state.slug !== "add" &&
                        this.state.slug !== undefined && (
                          <button
                            type="button"
                            onClick={this.handleRefresh}
                            className="detlet-text mr-2 pr-3"
                            disabled={this.state.isRefreshing}
                          >
                            <i className="fas fa-sync-alt mr-1" />
                          </button>
                        )}
                      {this.state.slug !== "add" &&
                        this.state.slug !== undefined &&
                        global.userPermissions.checkPermission(
                          "daily_logs-export"
                        ) && (
                          <button
                            type="button"
                            onClick={this.exportPdf}
                            className="detlet-text mr-2 pr-3 daily-logs-delete-button"
                          >
                            Export PDF
                          </button>
                        )}
                      {this.state.slug !== "add" &&
                        this.state.slug !== undefined &&
                        global.userPermissions.checkPermission(
                          "daily_logs-delete"
                        ) && (
                          <button
                            type="button"
                            onClick={() =>
                              this.opendeleteDailyLogModal(this.state.slug)
                            }
                            className="detlet-text mr-2 pr-3 daily-logs-delete-button"
                          >
                            Delete Daily Log
                          </button>
                        )}
                      {this.state.slug !== "add" &&
                        global.userPermissions.checkPermission(
                          "daily_logs-history"
                        ) && (
                          <a
                            href="#"
                            className="float-right detlet-text ml-2 pd-r-70"
                            onClick={(e) => {
                              e.preventDefault();
                              this.showVersionHistory();
                            }}
                          >
                            History
                          </a>
                        )}
                    </div>
                  </div>
                  <form
                    id="action_item_form"
                    onSubmit={this.onSubmitFun}
                    method="post"
                    encType="multipart/form-data"
                  >
                    <div className="m-0">
                      <div className="mg-t-0 mg-b-0">
                        <div className="az-content-label titleLable pd-l-70 pd-r-70">
                          Info
                        </div>
                        <div className="row align-items-basline flex-wrap m-0 pd-t-0 pd-b-0 pd-l-70 pd-r-70">
                          {this.state.slug !== "add" ? (
                            <>
                              <div className="col-md-6 col-lg-6 mg-t-5 mg-md-t-0 mg-b-15 pd-b-1 pd-l-70 pd-r-70">
                                <label className="form-label text-left">
                                  Title
                                </label>
                                <p>{this.state.title} </p>
                              </div>
                              <div className="col-md-6 col-lg-6 mg-t-5 mg-md-t-0 mg-b-15 pd-b-1 pd-l-70 pd-r-70">
                                <label className="form-label text-left">
                                  Property
                                </label>
                                <p>{this.state.propertyName} </p>
                              </div>
                              <div className="col-md-6 col-lg-6 mg-t-5 mg-md-t-0 mg-b-15 pd-b-1 pd-l-70 pd-r-70">
                                <label className="form-label text-left">
                                  Date
                                </label>
                                <p>
                                  {Moment(this.state.convert_created_at).format(
                                    "DD MMM, YY"
                                  )}
                                </p>
                              </div>

                              <div className="col-md-6 col-lg-6 mg-t-5 mg-md-t-0 mg-b-15 pd-b-1 pd-l-70 pd-r-70">
                                <label className="form-label text-left">
                                  Technician
                                </label>
                                <p>{this.state.full_name} </p>
                              </div>
                              {this.state.note && this.state.note.trim() !== "" && (
                                <div className="col-md-12 col-lg-12 mg-t-5 mg-md-t-0 mg-b-15 pd-b-1 pd-l-70 pd-r-70">
                                  <label className="form-label text-left">
                                    Note
                                  </label>
                                    <p
                                    dangerouslySetInnerHTML={{
                                      __html: this.modifyTaskName(
                                        this.state.note
                                      ),
                                    }}>
                                  </p>
                                </div>
                              )}
                              {/* Image Preview */}
                              <div className="col-md-12 col-lg-12 mg-t-5 mg-md-t-0 mg-b-15 pd-b-1 pd-l-70 pd-r-70">
                                <div className="daily_log_info_imgbox">
                                  {this.state.dailyLogImages
                                    ? this.state.dailyLogImages.map(
                                        (record, i) => {
                                          return (
                                            <div key={i} className="img_close">
                                              <a
                                                href={
                                                  record.uri_web
                                                    ? record.uri_web
                                                    : ""
                                                }
                                                rel="noreferrer"
                                                target="_blank"
                                              >
                                                <div className="pop-up-image-megnify">
                                                  <ReactImageMagnify
                                                    {...{
                                                      smallImage: {
                                                        alt: record.slug,
                                                        isFluidWidth: true,
                                                        src: record.uri_web
                                                          ? record.uri_web
                                                          : "",
                                                        onError: ({
                                                          currentTarget,
                                                        }) => {
                                                          currentTarget.onerror =
                                                            null; // prevents looping
                                                          currentTarget.src =
                                                            placeholderImage;
                                                        },
                                                      },
                                                      largeImage: {
                                                        src: record.uri_web
                                                          ? record.uri_web
                                                          : "",
                                                        width: 200,
                                                        height: 200,
                                                      },
                                                      enlargedImagePosition:
                                                        "beside",
                                                      enlargedImageContainerDimensions:
                                                        {
                                                          width: "300%",
                                                          height: "300%",
                                                        },
                                                      className:
                                                        "custom-image-magnify",
                                                    }}
                                                  />
                                                </div>
                                              </a>
                                              {global.userPermissions.checkPermission(
                                                "daily_logs-delete-thread"
                                              ) && (
                                                <>
                                                  <button
                                                    type="button"
                                                    key={"button" + i}
                                                    className="btn btn-danger btn_remove"
                                                    onClick={() =>
                                                      this.toggleModal(
                                                        record.slug
                                                      )
                                                    }
                                                  >
                                                    <span className="fa fa-times"></span>
                                                  </button>
                                                </>
                                              )}
                                            </div>
                                          );
                                        }
                                      )
                                    : ""}
                                </div>
                              </div>
                            </>
                          ) : (
                            <>
                              <div className="col-md-12">
                                <form
                                  id="daily_log_form"
                                  onSubmit={this.onSubmitFun}
                                  method="post"
                                  encType="multipart/form-data"
                                >
                                  <div className="row">
                                    <div className="col-md-6 col-lg-6 mg-t-5 mg-md-t-0 mg-b-15 pd-b-1 pd-l-70 pd-r-70">
                                      <label className="form-label text-left">
                                        Title
                                      </label>
                                      <Form.Control
                                        type="text"
                                        onChange={this.changeHandler}
                                        name="title"
                                        value={this.state.title}
                                        maxLength="50"
                                        tabIndex="1"
                                        autoComplete="off"
                                      />
                                      {this.state.errors.title ? (
                                        <div className="text-danger">
                                          {this.state.errors.title}
                                        </div>
                                      ) : (
                                        this.validator.message(
                                          "title",
                                          this.state.title,
                                          "required",
                                          { className: "text-danger" }
                                        )
                                      )}
                                    </div>
                                    <div className="col-md-6 col-lg-6 mg-t-5 mg-md-t-0 mg-b-15 pd-b-1 pd-l-70 pd-r-70">
                                      <label className="form-label text-left">
                                        Date
                                      </label>

                                      <Form.Control
                                        type="text"
                                        name="title"
                                        //  this.state.convert_created_at
                                        value={Moment(
                                          this.state.selectedDate
                                        ).format("DD MMM, YY")}
                                        maxLength="50"
                                        tabIndex="1"
                                        readOnly
                                        autoComplete="off"
                                      />
                                    </div>
                                    <div className="col-md-6 col-lg-6 mg-t-5 mg-md-t-0 mg-b-15 pd-b-1 pd-l-70 pd-r-70">
                                      <label className="form-label text-left mg-b-5">
                                        Property
                                      </label>
                                      {Number(
                                        localStorage.getItem(
                                          "activePropertyCount"
                                        )
                                      ) !== 1 ? (
                                        <>
                                          <input
                                            name="job_title"
                                            className="form-control"
                                            autoComplete="off"
                                            value={
                                              this.state.selectedProperty.label
                                            }
                                            onChange={this.changeHandler}
                                            readOnly
                                          />
                                          {/* <Select
                                          className="multiselect new_drop"
                                          menuPlacement="auto"
                                          value={
                                            this.state.selectedProperty
                                              ? this.state.selectedProperty
                                              : this.state.selectedPropertyList
                                          }
                                          options={
                                            this.state.selectedProperty
                                              ? this.state.selectedProperty
                                              : this.state.propertyList
                                          }
                                          onChange={(value) =>
                                            this.handleChangeProperty(value)
                                          }
                                          defaultValue={
                                            this.state.selectedPropertyList
                                          }
                                          autoComplete="off"
                                          getOptionValue={(option) =>
                                            `${option.label}`
                                          }
                                          styles={customStyles}
                                          theme={(theme) => ({
                                            ...theme,
                                            colors: {
                                              ...theme.colors,
                                              primary75: "#808080",
                                              primary50: "#808080",
                                              primary25: "#808080",
                                            },
                                          })}
                                          disabled={
                                            this.state.selectedProperty
                                              ? true
                                              : false
                                          }
                                        /> */}
                                        </>
                                      ) : (
                                        <input
                                          name="job_title"
                                          className="form-control"
                                          autoComplete="off"
                                          value={this.state.propertyNameDrop}
                                          onChange={this.changeHandler}
                                          readOnly
                                        />
                                      )}
                                      {!this.state.selectedProperty &&
                                        (this.state.errors.property_slug ? (
                                          <div className="text-danger">
                                            {this.state.errors.property_slug}
                                          </div>
                                        ) : (
                                          this.validator.message(
                                            "Property",
                                            this.state.property_slug,
                                            "required",
                                            { className: "text-danger" }
                                          )
                                        ))}
                                    </div>
                                    {this.state.templateData && (
                                      <div className="row align-items-basline col-md-12 col-lg-12 flex-wrap m-0 pd-t-0 pd-b-0 pd-l-70 pd-r-70">
                                        <div className="col-md-12 mg-t-5 mg-md-t-0 mg-b-15 pd-b-1 pd-l-0 pd-r-0">
                                          <div className="daily-log-container">
                                            {/* <h2>{this.state.templateData.template_name}</h2> */}
                                            <div className="d-flex justify-content-end mb-3">
                                              <a
                                                href="#logEntriesSection"
                                                className="detlet-text"
                                                onClick={(e) => {
                                                  e.preventDefault();
                                                  document
                                                    .getElementById(
                                                      "logEntriesSection"
                                                    )
                                                    .scrollIntoView({
                                                      behavior: "smooth",
                                                      block: "start",
                                                    });
                                                  // Also expand the section if needed
                                                  const logSectionIndex =
                                                    this.state.templateSections.findIndex(
                                                      (s) =>
                                                        s.section_type ===
                                                        "log_entries"
                                                    );
                                                  if (logSectionIndex >= 0) {
                                                    this.setState(
                                                      (prevState) => ({
                                                        collapsedSections: {
                                                          ...prevState.collapsedSections,
                                                          [logSectionIndex]: false,
                                                        },
                                                      })
                                                    );
                                                  }
                                                }}
                                              >
                                                GO TO LOG ENTRIES
                                                <img
                                                  className="downArrow"
                                                  src={downArrow}
                                                  alt="Down Arrow"
                                                />
                                              </a>
                                            </div>
                                            {this.state.templateSections.map(
                                              (section, index) =>
                                                this.renderSection(
                                                  section,
                                                  index
                                                )
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </form>
                              </div>
                            </>
                          )}
                        </div>
                        {this.state.is_type === 1 &&
                        this.state.daily_log_thread_length > 0 ? (
                          <>
                            <div className="row align-items-basline flex-wrap m-0 pd-t-0 pd-b-0 pd-l-70 pd-r-70">
                              <div className="col-md-12 mg-t-5 mg-md-t-0 mg-b-15 pd-b-1 pd-l-0 pd-r-70">
                                <div className="az-content-label titleLable pl-0">
                                  <span className="pd-t-10 d-block">
                                    Daily Log Entries
                                  </span>
                                </div>
                                <hr className="mg-t-30 mg-b-20 pd-t-1 pd-b-3 w-max-100"></hr>
                              </div>
                            </div>
                          </>
                        ) : (
                          ""
                        )}

                        {/* Template content */}
                        {this.state.is_type === 2 &&
                          this.state.templateData &&
                          this.state.slug !== "add" && (
                            <div className="row align-items-basline flex-wrap m-0 pd-t-0 pd-b-0 pd-l-70 pd-r-70">
                              <div className="col-md-12 mg-t-5 mg-md-t-0 mg-b-15 pd-b-1 pd-l-0 pd-r-0">
                                <div className="daily-log-container">
                                  {/* <h2>{this.state.templateData.template_name}</h2> */}
                                  <div className="d-flex justify-content-end mb-3">
                                    <a
                                      href="#logEntriesSection"
                                      className="detlet-text"
                                      onClick={(e) => {
                                        e.preventDefault();
                                        document
                                          .getElementById("logEntriesSection")
                                          .scrollIntoView({
                                            behavior: "smooth",
                                            block: "start",
                                          });
                                        // Also expand the section if needed
                                        const logSectionIndex =
                                          this.state.templateSections.findIndex(
                                            (s) =>
                                              s.section_type === "log_entries"
                                          );
                                        if (logSectionIndex >= 0) {
                                          this.setState((prevState) => ({
                                            collapsedSections: {
                                              ...prevState.collapsedSections,
                                              [logSectionIndex]: false,
                                            },
                                          }));
                                        }
                                      }}
                                    >
                                      GO TO LOG ENTRIES
                                      <img
                                        className="downArrow"
                                        src={downArrow}
                                        alt="Down Arrow"
                                      />
                                    </a>
                                  </div>
                                  {this.state.templateSections.map(
                                    (section, index) =>
                                      this.renderSection(section, index)
                                  )}
                                  <div
                                    className={`${
                                      this.state.showVersionHistory
                                        ? "d-flex align-items-center justify-content-between edit-btn-float-btn col-md-7"
                                        : "d-flex align-items-center justify-content-between edit-btn-float-btn"
                                    }`}
                                  >
                                    {this.state.slug !== "add" ? (
                                      <div className="flex-wrap-bothBtn">
                                        {global.userPermissions.checkPermission(
                                          "daily_logs-delete"
                                        ) &&
                                          (this.state.slug !== undefined ? (
                                            <>
                                              <button
                                                type="button"
                                                onClick={() => {
                                                  this.opendeleteDailyLogModal(
                                                    this.state.slug
                                                  );
                                                }}
                                                className="detlet-text mg-r-20"
                                              >
                                                Delete Daily log
                                              </button>
                                            </>
                                          ) : (
                                            ""
                                          ))}
                                      </div>
                                    ) : (
                                      ""
                                    )}
                                    {global.userPermissions.checkPermission("daily_logs-add") && this.state.is_thread_enable === 1 && (
                                      <div className="text-right">
                                        <button
                                          className="gf-btn-lg-stroke mg-l-2"
                                          onClick={this.saveDailyLogs}
                                          disabled={
                                            this.state.isSubmit ? true : false
                                          }
                                        >
                                          {this.state.isSubmit
                                            ? global.loader
                                            : "save"}
                                        </button>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                        {this.state.is_type === 1 &&
                        this.state.is_thread_enable == 1 ? (
                          <>
                            <Modal
                              show={this.state.addModal}
                              centered
                              className="daily_log_modal"
                            >
                              <Modal.Body className="width_402 p-4 border_radius_14">
                                <Alerts
                                  show={this.state.showAlertModal1}
                                  type={this.state.alertModalType1}
                                  title={this.state.alertModalTitle1}
                                  message={this.state.alertModalMessage1}
                                />
                                <span
                                  className="welcomeClose"
                                  onClick={() => this.closeModal()}
                                >
                                  {global.closee}
                                </span>

                                <h3 className="text-center">
                                  {"Add Daily Logs"}
                                </h3>
                                <label>Title</label>
                                <form
                                  id="daily_log_thread_form"
                                  onSubmit={this.onSubmitFun}
                                  method="post"
                                  encType="multipart/form-data"
                                >
                                  <Form.Control
                                    onChange={this.changeHandler}
                                    ref={(input) => {
                                      this.nameInput = input;
                                    }}
                                    name="daily_log_title"
                                    value={this.state.daily_log_title}
                                    className="form-control max_width_100 "
                                    id="inlineFormInput"
                                    type="text"
                                    maxLength="50"
                                    autoComplete="off"
                                    autoFocus={true}
                                  />
                                  {this.state.errors.daily_log_title ? (
                                    <div className="text-danger">
                                      {this.state.errors.daily_log_title}
                                    </div>
                                  ) : (
                                    this.validator.message(
                                      "title",
                                      this.state.daily_log_title,
                                      "required",
                                      { className: "text-danger" }
                                    )
                                  )}

                                  <div className="daily_log_image_upload">
                                    <div className="row m-0">
                                      <FileWidget
                                        fieldName="file_name"
                                        fieldTitle=""
                                        fieldLabel=""
                                        checkValidation="true"
                                        allowedType="jpeg,jpg,png,JPEG,JPG,PNG,GIF,gif"
                                        maxFileSize={5}
                                        maxFileSizeType="mb"
                                        maxFileAllowed={10}
                                        uploadOn="s3"
                                        refTableId="7"
                                        displayFileName=""
                                        documentTypeSlug=""
                                        mediaType={1}
                                        sortOrder=""
                                        statusId=""
                                        helpText="To download sample file."
                                        sampleFileUrl="/sample.jpg"
                                        drag="false"
                                        dragText=""
                                        inputClassName="form-control"
                                        labelClassName="form-label"
                                        formID="daily_log_thread_form"
                                        uploadType="multiple"
                                        resizeOptions="width:200,height:200,maintainAspectRatio:true,resizeDestinationFolder:thumb||width:300,height:300,maintainAspectRatio:false,resizeDestinationFolder:thumb22"
                                        destinationFolder="daily-log-threads"
                                        uploadedFiles={
                                          this.state.profile_image2
                                        }
                                        deletedFiles={
                                          this.state.deletedFileList
                                        }
                                        acceptOnly="image/*"
                                        displayPreviewStyle="vertical"
                                        newRelatedFilesDescChange={
                                          this.newRelatedFilesDescChange
                                        }
                                        currentFile={
                                          this.state.daily_log_thread_length
                                        }
                                      />
                                    </div>
                                    {/* Image Preview end*/}
                                  </div>
                                </form>
                                <div className="d-flex cnt_center mt-3 row">
                                  <button
                                    type="button"
                                    className="m-0 btn btn-outline-light btn-block"
                                    onClick={() => this.closeModal()}
                                  >
                                    Cancel
                                  </button>
                                  <button
                                    type="button"
                                    className="m-0 btn btn btn-success btn-block"
                                    onClick={this.saveDailyLogThread}
                                    disabled={
                                      this.state.isSubmit ? true : false
                                    }
                                  >
                                    {this.state.isSubmit
                                      ? global.loader
                                      : "ADD"}
                                  </button>
                                </div>
                              </Modal.Body>
                            </Modal>
                          </>
                        ) : (
                          ""
                        )}
                        <div className="add-daily-log-float-btn">
                          <div className="row row-xs align-items-center flex-wrap m-0 pd-t-15 pd-b-0 pd-l-140 pd-r-80">
                            <div className="col-md-12 btnNavigate d-flex align-items-center justify-content-between flex-row-reverse flex-wrap-bothBtn p-0">
                              {this.state.slug === "add" ? (
                                <div className="d-flex align-items-center justify-content-end pr-4 btn-box-daily-log">
                                  <Link
                                      to={{
                                        pathname: this.props.location.state?.isfromdetailpage && this.props.location.state?.olddailylogslug
                                          ? `/daily-log/${this.props.location.state.olddailylogslug}` // Construct URL if conditions are true
                                          : "/daily-logs", // Default URL
                                      }}
                                      onClick={(e) => {
                                        // If we are redirecting to a specific daily log and not just the listing page, force a page reload
                                        if (this.props.location.state?.isfromdetailpage && this.props.location.state?.olddailylogslug) {
                                          e.preventDefault(); // Prevent the default Link behavior
                                          window.location.href = `/daily-log/${this.props.location.state.olddailylogslug}`; // Force page reload
                                        }
                                      }}
                                    >
                                    <button
                                      className="gf-btn-lg-outline mg-r-7"
                                      type="button"
                                      disabled={
                                        this.state.isSubmit ? true : false
                                      }
                                    >
                                      Cancel
                                    </button>
                                  </Link>
                                  <button
                                    className="gf-btn-lg-stroke mg-l-2"
                                    type="button"
                                    onClick={this.saveDailyLogs}
                                    disabled={
                                      this.state.isSubmit ? true : false
                                    }
                                  >
                                    {this.state.isSubmit
                                      ? global.loader
                                      : this.state.slug !== undefined
                                      ? "Add"
                                      : ""}
                                  </button>
                                </div>
                              ) : (
                                ""
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* for task */}
                    {this.state.is_type === 1 && this.state.slug !== "add" ? (
                      <>
                        <div className="row align-items-basline flex-wrap m-0 pd-t-0 pd-b-0 pd-l-70 pd-r-70 daily_logy_cnt">
                          <div className="col-md-12 p-0">
                            <div className="brandSection">
                              <div className="brandList dashboardRightcard d-flex flex-wrap justify-content-between align-items-center pt-0 pd-l-70 pd-r-70 ">
                                {this.state.daily_log_thread
                                  ? this.state.daily_log_thread.map(
                                      (element, index) => (
                                        <div
                                          className="form-group col-md-12 pd-l-0 pd-r-70 "
                                          key={index}
                                        >
                                          <div className="az-content-label titleLable pl-0 mg-cust-b-5">
                                            {element.title ? element.title : ""}
                                          </div>
                                          <p className="az-daily-mid_text p-0 mg-cust-b-5">
                                            {Moment(
                                              element.convert_created_at
                                            ).format(
                                              "DD MMM, YY - hh:mm A"
                                            )}{" "}
                                            |{" "}
                                            {element.created_by &&
                                            element.created_by.full_name
                                              ? element.created_by.full_name
                                              : ""}
                                            {global.userPermissions.checkPermission(
                                              "daily_logs-delete-thread"
                                            ) &&
                                              (element.slug !== undefined ? (
                                                <>
                                                  <button
                                                    type="button"
                                                    onClick={() => {
                                                      this.opendeleteDailyLogThreadModal(
                                                        element.slug
                                                      );
                                                    }}
                                                    className="detlet-text mg-l-20"
                                                  >
                                                    <i className="fas fa-trash-alt delete-icon"></i>{" "}
                                                    {/* Font Awesome trash icon */}
                                                  </button>
                                                </>
                                              ) : (
                                                ""
                                              ))}
                                          </p>
                                          <p className="az-daily-para-text">
                                            {element.comment ? (
                                              <div
                                                dangerouslySetInnerHTML={{
                                                  __html: this.modifyTaskName(
                                                    element.comment
                                                  ),
                                                }}
                                              />
                                            ) : (
                                              ""
                                            )}
                                            {/* Image Preview */}
                                            <div className="row mt-3">
                                              <div className="col-md-12">
                                                <div className="daily_log_info_imgbox">
                                                  {element.images
                                                    ? element.images.map(
                                                        (record, i) => {
                                                          return (
                                                            <div
                                                              key={i}
                                                              className="img_close"
                                                            >
                                                              <a
                                                                href={
                                                                  record.uri_web
                                                                    ? record.uri_web
                                                                    : ""
                                                                }
                                                                rel="noreferrer"
                                                                target="_blank"
                                                              >
                                                                <div className="pop-up-image-megnify">
                                                                  <ReactImageMagnify
                                                                    {...{
                                                                      smallImage:
                                                                        {
                                                                          alt: record.slug,
                                                                          isFluidWidth: true,
                                                                          src: record.uri_web
                                                                            ? record.uri_web
                                                                            : "",
                                                                          onError:
                                                                            ({
                                                                              currentTarget,
                                                                            }) => {
                                                                              currentTarget.onerror =
                                                                                null; // prevents looping
                                                                              currentTarget.src =
                                                                                placeholderImage;
                                                                            },
                                                                        },
                                                                      largeImage:
                                                                        {
                                                                          src: record.uri_web
                                                                            ? record.uri_web
                                                                            : "",
                                                                          width: 200,
                                                                          height: 200,
                                                                        },
                                                                      enlargedImageContainerDimensions:
                                                                        {
                                                                          width:
                                                                            "300%",
                                                                          height:
                                                                            "300%",
                                                                        },
                                                                      enlargedImagePosition:
                                                                        "beside",
                                                                      className:
                                                                        "custom-image-magnify",
                                                                    }}
                                                                  />
                                                                </div>
                                                              </a>
                                                              {global.userPermissions.checkPermission(
                                                                "daily_logs-delete-thread"
                                                              ) && (
                                                                <>
                                                                  <button
                                                                    type="button"
                                                                    key={
                                                                      "button" +
                                                                      i
                                                                    }
                                                                    className="btn btn-danger btn_remove"
                                                                    onClick={() =>
                                                                      this.toggleModal(
                                                                        record.slug
                                                                      )
                                                                    }
                                                                  >
                                                                    <span className="fa fa-times"></span>
                                                                  </button>
                                                                </>
                                                              )}
                                                            </div>
                                                          );
                                                        }
                                                      )
                                                    : ""}
                                                </div>
                                              </div>
                                            </div>
                                          </p>
                                          <hr className="mg-t-30 mg-b-20 mr-0 ml-0"></hr>
                                        </div>
                                      )
                                    )
                                  : ""}
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                    ) : (
                      ""
                    )}
                  </form>
                </div>
              </div>
              {this.state.showVersionHistory && (
                <div className="col-md-3">
                  <div className="version-history-bottom-panel">
                    <div className="panel-header">
                      <h4 className="az-content-label titleLable">Versions</h4>
                      <button
                        className="close-btn"
                        onClick={() =>
                          this.setState({ showVersionHistory: false })
                        }
                      >
                        ×
                      </button>
                    </div>
                    <div className="version-list">
                      {this.state.versions.length > 0 ? (
                        this.state.versions.map((version, index) => (
                          <Link
                            to={`/daily-log/${this.props.match.params.slug}/versions/${version.slug}`}
                            key={index}
                            className={`version-item ${
                              this.props.match.params.versionId ===
                              version.version_id
                                ? "active"
                                : ""
                            }`}
                          >
                            <div className="version-number">
                              Version {version.version}
                            </div>
                            <div className="version-meta">
                              {Moment(version.created_at).format(
                                "DD MMM, YY - hh:mm A"
                              )}
                            </div>
                            <div className="version-author">
                              Edited by: {version?.full_name || "Unknown"}
                            </div>
                          </Link>
                        ))
                      ) : (
                        <div className="no-versions-message">
                          No versions available
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </main>
        {this.state.showModalImage && (
          <DeleteImageModal
            showModalImage={this.state.showModalImage}
            slug={this.state.imageSlug}
            onRemove={this.handleImageDelete}
          />
        )}
        <Modal show={this.state.deleteDailyLogModal} centered>
          <Modal.Body className="width_402 p-4 border_radius_14">
            <div className="text-center">
              {/* <img src={modaldeleteicon} alt="modal-delete-icon" /> */}
              <h3>Delete Daily Log Thread?</h3>
              <p className="pd-l-50 pd-r-50 pd-b-20 model_first_p">
                Do you really want to delete this Daily Log Thread? This process
                cannot be undone.
              </p>
              <div className="d-flex cnt_center mt-3 row">
                <button
                  type="button"
                  className=" m-0 btn btn-outline-light btn-block"
                  onClick={() => this.closedeleteDailyLogModal()}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className=" m-0 btn btn btn-danger btn-block"
                  onClick={() => this.deleteDailyLog(this.state.slug)}
                  disabled={this.state.isDelete ? true : false}
                >
                  {this.state.isDelete ? global.loader : "Delete"}
                </button>
              </div>
            </div>
          </Modal.Body>
        </Modal>
        <Modal show={this.state.deleteDailyLogThreadModal} centered>
          <Modal.Body className="width_402 p-4 border_radius_14">
            <div className="text-center">
              {/* <img src={modaldeleteicon} alt="modal-delete-icon" /> */}
              <h3>Delete Daily Log Entry ?</h3>
              <p className="pd-l-50 pd-r-50 pd-b-20 model_first_p">
                Do you really want to delete this Daily Log Entry ? This process
                cannot be undone.
              </p>
              <div className="d-flex cnt_center mt-3 row">
                <button
                  type="button"
                  className=" m-0 btn btn-outline-light btn-block"
                  onClick={() => this.closedeleteDailyLogThreadModal()}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className=" m-0 btn btn btn-danger btn-block"
                  onClick={() =>
                    this.deleteDailyLogThread(this.state.threadSlug)
                  }
                  disabled={this.state.isDelete ? true : false}
                >
                  {this.state.isDelete ? global.loader : "Delete"}
                </button>
              </div>
            </div>
          </Modal.Body>
        </Modal>

        <Modal
          show={this.state.showLogEntryModal}
          onHide={this.closeLogEntryModal}
          centered
          backdrop="static"
          className="daily-log-modal"
          onEntered={this.focusQuillEditor}
        >
          <Modal.Body>
            <span className="welcomeClose" onClick={() => this.closeModal()}>
              {global.closee}
            </span>
            <h3 className="text-center">
              {/* {this.state.isEditingEntry ? "Edit Log Entry" : "Add Log Entry"} - * */}
              {this.state.currentLogCategory}
            </h3>
            <div className="form-group">
              <label>Note</label>
              <div id="toolbar-modal">
                <button className="ql-bold"></button>
                <button className="ql-italic"></button>
                <button className="ql-underline"></button>
                <button className="ql-link"></button>
              </div>
              <ReactQuill
                ref={this.modalQuillRef}
                theme="snow"
                name="newLogEntry"
                value={this.state.newLogEntry}
                onChange={this.handleChangeModal}
                modules={modulesmodal}
                formats={global.formats}
                className="custom_editor_style"
              />
              {this.state.showModal && (
                <LinkModal
                  onClose={this.handleModalClose}
                  onSubmit={this.handleModalSubmit}
                  onRemove={this.handleModalRemove}
                  url={this.state.url}
                  text={this.state.text}
                  isEditing={this.state.isEditing}
                  showModal={this.state.showModal}
                />
              )}
            </div>
            <div className="note_image_box">
              <div className="">
                <input
                  onChange={this.handleImageUpload}
                  className="px-0"
                  type="file"
                  name="file_name"
                  accept="image/*"
                  multiple
                />

                {/* Image Preview */}
                <ul className="img_view_loop">
                  {this.state.logEntryImages.map((image, index) => (
                    <li key={image.id}>
                      <div className="img_close">
                        <a
                          href={image.src || image.uri_web}
                          target="_blank"
                          rel="noreferrer"
                        >
                          <img
                            src={image.src || image.uri_web}
                            className="brand_list_image"
                            alt="Log entry preview"
                            onError={({ currentTarget }) => {
                              currentTarget.onerror = null;
                              currentTarget.src = placeholderImage;
                            }}
                          />
                        </a>
                        <button
                          type="button"
                          className="btn btn_remove position-absolute"
                          onClick={() => this.deleteLogEntryImage(index)}
                        >
                          <span className="fa fa-times"></span>
                        </button>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
            {error && <p style={{ color: "red" }}>{error}</p>}
            {/* Image Preview end*/}
            {this.state.logEntryImages.length !== 0 &&
              this.state.isUploading && (
                <div className="upload-progress-container mt-3">
                  <div className="upload-status mb-2 text-black">
                    {this.state.uploadStatus}
                  </div>
                  <div className="progress">
                    <div
                      className="progress-bar progress-bar-striped progress-bar-animated"
                      role="progressbar"
                      style={{ width: `${this.state.uploadProgress}%` }}
                      aria-valuenow={this.state.uploadProgress}
                      aria-valuemin="0"
                      aria-valuemax="100"
                    >
                      {this.state.uploadProgress}%
                    </div>
                  </div>
                </div>
              )}
            <div className="cnt_center d-flex mt-3">
              <button
                className=" m-0 btn btn-outline-light btn-block"
                onClick={this.closeLogEntryModal}
                disabled={this.state.loading}
              >
                Cancel
              </button>
              <button
                className=" m-0 btn btn btn-success btn-block"
                onClick={this.saveLogEntry}
                disabled={!this.state.newLogEntry.trim() || this.state.loading}
              >
                {this.state.loading ? (
                  <>
                    {this.state.isUploading ? <>Saving...</> : <>Saving...</>}
                  </>
                ) : this.state.isEditingEntry ? (
                  "Update"
                ) : (
                  "Add"
                )}
              </button>
            </div>
          </Modal.Body>
        </Modal>

        {/* Reply Modal */}
        <Modal
          show={this.state.showReplyModal}
          onHide={this.closeReplyModal}
          centered
          backdrop="static"
          className="daily-log-reply-modal"
          onEntered={() => this.focusQuillEditorReply(this.quillRef, true)}
        >
          <Modal.Body>
            <span
              className="welcomeClose"
              onClick={() => this.closeReplyModal()}
            >
              {global.closee}
            </span>
            <h3 className="text-center">
              {" "}
              {this.state.currentReplyIndex !== null
                ? "Edit Reply"
                : "Add Reply"}{" "}
              <div
                className="log-entry-preview"
                dangerouslySetInnerHTML={{
                  __html: this.limitTextTo50Words(
                    this.state.originalLogEntryText
                  ),
                }}
              />
            </h3>
            <div className="form-group">
              <label>Reply</label>
              <CustomToolbar />
              <ReactQuill
                ref={this.quillRef}
                theme="snow"
                name="newReply"
                value={this.state.newReply || ""}
                onChange={this.handleChangeReply}
                modules={modules}
                formats={global.formats}
                className="custom_editor_style"
              />
              {this.state.showModal && (
                <LinkModal
                  onClose={this.handleModalClose}
                  onSubmit={this.handleModalSubmit}
                  onRemove={this.handleModalRemove}
                  url={this.state.url}
                  text={this.state.text}
                  isEditing={this.state.isEditing}
                  showModal={this.state.showModal}
                />
              )}
            </div>

            {/* Add image upload section for replies */}
            <div className="note_image_box">
              <div className="">
                <input
                  onChange={this.handleReplyImageUpload}
                  className="px-0"
                  type="file"
                  name="reply_file_name"
                  accept="image/*"
                  multiple
                />

                {/* Image Preview */}
                <ul className="img_view_loop">
                  {this.state.replyImages.map((image, index) => (
                    <li key={image.id}>
                      <div className="img_close">
                        <a
                          href={image.src || image.uri_web}
                          target="_blank"
                          rel="noreferrer"
                        >
                          <img
                            src={image.src || image.uri_web}
                            className="brand_list_image"
                            alt="Reply preview"
                            onError={({ currentTarget }) => {
                              currentTarget.onerror = null;
                              currentTarget.src = placeholderImage;
                            }}
                          />
                        </a>
                        <button
                          type="button"
                          className="btn btn_remove position-absolute"
                          onClick={() => this.deleteReplyImage(index)}
                        >
                          <span className="fa fa-times"></span>
                        </button>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            {error && <p style={{ color: "red" }}>{error}</p>}

            {/* Upload progress for replies */}
            {this.state.replyImages.length !== 0 &&
              this.state.isUploadingReply && (
                <div className="upload-progress-container mt-3">
                  <div className="upload-status mb-2 text-black">
                    {this.state.replyUploadStatus}
                  </div>
                  <div className="progress">
                    <div
                      className="progress-bar progress-bar-striped progress-bar-animated"
                      role="progressbar"
                      style={{ width: `${this.state.replyUploadProgress}%` }}
                      aria-valuenow={this.state.replyUploadProgress}
                      aria-valuemin="0"
                      aria-valuemax="100"
                    >
                      {this.state.replyUploadProgress}%
                    </div>
                  </div>
                </div>
              )}

            <div className="cnt_center d-flex mt-5">
              <button
                className="m-0 btn btn-outline-light btn-block"
                onClick={this.closeReplyModal}
                disabled={this.state.loading}
              >
                Cancel
              </button>
              <button
                className="m-0 btn btn btn-success btn-block"
                onClick={this.saveReply}
                disabled={!this.state.newReply.trim() || this.state.loading}
              >
                {this.state.loading ? (
                  <>
                    {this.state.isUploadingReply ? (
                      <>Saving...</>
                    ) : (
                      <>Saving...</>
                    )}
                  </>
                ) : this.state.currentReplyIndex !== null ? (
                  "Update"
                ) : (
                  "Reply"
                )}
              </button>
            </div>
          </Modal.Body>
        </Modal>

        <Modal show={this.state.showDeleteReplyModal} centered>
          <Modal.Body className="width_402 p-4 border_radius_14">
            <div className="text-center">
              <h3>Delete Reply?</h3>
              <p className="pd-l-50 pd-r-50 pd-b-20 model_first_p">
                Do you really want to delete this reply? This process cannot be
                undone.
              </p>
              <div className="d-flex cnt_center mt-3 row">
                <button
                  type="button"
                  className="m-0 btn btn-outline-light btn-block"
                  onClick={this.closeDeleteReplyModal}
                  disabled={this.state.loading}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="m-0 btn btn-danger btn-block"
                  onClick={this.deleteReplyConfirmed}
                  disabled={this.state.loading}
                >
                  {this.state.loading ? global.loader : "Delete"}
                </button>
              </div>
            </div>
          </Modal.Body>
        </Modal>
        <Modal show={this.state.showDeleteThreadModal} centered>
          <Modal.Body className="width_402 p-4 border_radius_14">
            <div className="text-center">
              <h3>Delete Thread Entry?</h3>
              <p className="pd-l-50 pd-r-50 pd-b-20 model_first_p">
                Do you really want to delete this thread entry? This process
                cannot be undone.
              </p>
              <div className="d-flex cnt_center mt-3 row">
                <button
                  type="button"
                  className="m-0 btn btn-outline-light btn-block"
                  onClick={this.closeDeleteThreadModal}
                  disabled={this.state.loading}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="m-0 btn btn-danger btn-block"
                  onClick={this.deleteThreadConfirmed}
                  disabled={this.state.loading}
                >
                  {this.state.loading ? global.loader : "Delete"}
                </button>
              </div>
            </div>
          </Modal.Body>
        </Modal>

        <Modal show={showConfirmModal} centered onHide={this.cancelNavigation}>
          <Modal.Body className="width_402 p-4 border_radius_14">
            <div className="text-center">
              <h3>Unsaved Changes</h3>
              <p className="pd-l-50 pd-r-50 pd-b-20 model_first_p">
                Are you sure you want to go back? Any unsaved changes will be
                lost.
              </p>
              <div className="d-flex cnt_center mt-3 row">
                <button
                  type="button"
                  className="m-0 btn btn-outline-light btn-block"
                  onClick={this.cancelNavigation}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="m-0 btn btn-danger btn-block"
                  onClick={this.confirmNavigation}
                >
                  Ok
                </button>
              </div>
            </div>
          </Modal.Body>
        </Modal>

        <Modal show={showAddNewdailylogConfirmModal} centered onHide={this.cancelNavigation}>
          <Modal.Body className="width_402 p-4 border_radius_14">
            <div className="text-center">
              <p className="pd-l-50 pd-r-50 pd-b-20 model_first_p">
                  <div
                      dangerouslySetInnerHTML={{
                        __html: this.state.popupContentForDetail,
                      }}
                    />
              </p>

              <div className="d-flex cnt_center mt-3 row">
                <button
                  type="button"
                  className="m-0 btn btn-outline-light btn-block"
                  onClick={this.cancelNavigation}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="m-0 btn btn-danger btn-block"
                  onClick={this.addnewdailylog}
                >
                  Ok
                </button>
              </div>
            </div>
          </Modal.Body>
        </Modal>

        <Modal show={showPastDatedailylogInfoModal} centered onHide={this.cancelNavigation}>
          <Modal.Body className="width_402 p-4 border_radius_14">
            <div className="text-center">
              <p className="pd-l-50 pd-r-50 pd-b-20 model_first_p">
                <div
                    dangerouslySetInnerHTML={{
                      __html: this.state.popupContentForDetail,
                    }}
                  />
              </p>
              <div className="d-flex cnt_center mt-3 row">
                <button
                  type="button"
                  className="m-0 btn btn-outline-light btn-block"
                  onClick={this.cancelNavigation}
                >
                  OK
                </button>
              </div>
            </div>
          </Modal.Body>
        </Modal>

        {/* Event Detail Modal */}
        <Modal
          show={this.state.showEventDetailModal}
          onHide={this.closeEventDetailModal}
          centered
          backdrop="static"
          className=""
        >
          <Modal.Body>
            <span
              className="welcomeClose"
              onClick={() => this.closeEventDetailModal()}
            >
              {global.closee}
            </span>

            <div className="modal-overlay">
              <div className="event-modal">
                <h3 className="text-center">{"Event Detail"}</h3>

                <div className="form-group">
                  <label>Property</label>
                  <input
                    type="text"
                    name="title"
                    value={this.state.eventDetailData.property?.property_name}
                    className="form-control"
                    readOnly
                  />
                </div>

                <div className="form-group">
                  <label>Event Title</label>
                  <input
                    type="text"
                    name="title"
                    value={this.state.eventDetailData.title}
                    className="form-control"
                    readOnly
                  />
                </div>
                <div className="form-group edit-event-checkbox-log">
                  <label className="check_cust">
                    <input
                      type="checkbox"
                      name="recurrence"
                      checked={this.state.eventDetailData.recurrence}
                      disabled
                    />
                    <span className="checkmark"></span>
                    Repeat Event
                  </label>
                </div>

                <div className="row">
                  <div
                    className={
                      this.state.eventDetailData.schedule_type === 2
                        ? "col-md-6"
                        : "col-md-12"
                    }
                  >
                    <div className="form-group">
                      <label>Schedule Type</label>
                      <input
                        type="text"
                        name="schedule_type_name"
                        value={this.state.eventDetailData.schedule_type_name}
                        className="form-control"
                        readOnly
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    {this.state.eventDetailData.schedule_type === 2 && (
                      <div className="form-group">
                        <label>Weekday</label>
                        <input
                          type="text"
                          name="schedule_type_name"
                          value={this.state.eventDetailData.weekday}
                          className="form-control"
                          readOnly
                        />
                      </div>
                    )}
                  </div>
                </div>

                {/* REORDERED FIELDS START HERE */}
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Start Date</label>
                      <input
                        type="text"
                        name="start_date"
                        value={
                          this.state.eventDetailData.start_date
                            ? Moment(
                                this.state.eventDetailData.start_date
                              ).format("DD MMM, YYYY")
                            : ""
                        }
                        className="form-control"
                        readOnly
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Start Time</label>
                      <input
                        type="text"
                        name="start_time"
                        value={
                          this.state.eventDetailData.start_time
                            ? this.formatTime(
                                this.state.eventDetailData.start_time
                              )
                            : ""
                        }
                        className="form-control"
                        readOnly
                      />
                    </div>
                  </div>

                  {this.state.eventDetailData.recurrence ? (
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>End Date</label>
                        <input
                          type="text"
                          name="recurrence_end_date"
                          value={
                            this.state.eventDetailData.recurrence_end_date
                              ? Moment(
                                  this.state.eventDetailData.recurrence_end_date
                                ).format("DD MMM, YYYY")
                              : ""
                          }
                          className="form-control"
                          readOnly
                        />
                      </div>
                    </div>
                  ) : (
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>End Date</label>
                        <input
                          type="text"
                          name="end_date"
                          value={
                            this.state.eventDetailData.end_date
                              ? Moment(
                                  this.state.eventDetailData.end_date
                                ).format("DD MMM, YYYY")
                              : ""
                          }
                          className="form-control"
                          readOnly
                        />
                      </div>
                    </div>
                  )}
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>End Time</label>
                      <input
                        type="text"
                        name="end_time"
                        value={
                          this.state.eventDetailData.end_time
                            ? this.formatTime(
                                this.state.eventDetailData.end_time
                              )
                            : ""
                        }
                        className="form-control"
                        readOnly
                      />
                    </div>
                  </div>
                </div>
                {/* REORDERED FIELDS END HERE */}

                <div className="form-group">
                  <label>Visibility</label>
                  <input
                    type="text"
                    name="visibility"
                    value={this.state.eventDetailData.visibility}
                    className="form-control"
                    readOnly
                  />
                </div>

                <div className="form-group">
                  <label>Remarks (Optional)</label>
                  <textarea
                    name="remarks"
                    value={this.state.eventDetailData.remarks}
                    className="form-control"
                    readOnly
                  />
                </div>

                <div className="modal-actions daily-log-event-modal-action">
                  <button
                    className="btn btn-outline-light btn-block"
                    onClick={this.closeEventDetailModal}
                    disabled={this.state.loading}
                  >
                    OK
                  </button>
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

export default DailyLogDetail;
